import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import _14x151 from "./14x151.png";
import _14x152 from "./14x152.png";
import _14x153 from "./14x153.png";
import _14x154 from "./14x154.png";

const width = '70'
const height = 'auto'
const viewBox = '0 0 477 241'

const getDimensions = (size, sizes) => {
  if (size && typeof size.width === 'number' && typeof size.height === 'number') {
    return size
  }
  return size && sizes[size]
    ? sizes[size]
    : { width, height }
}

const getCss = (size, sizes, fillColor, fillColorRule, noStyles) => {
  if (noStyles) { return '' }
  const dimensions = getDimensions(size, sizes)
  const fillRule = fillColor && fillColorRule ? `${fillColorRule}{ fill: ${fillColor}; }` : ''
  return css`
    width: ${dimensions.width}%;
    height: ${dimensions.height};
    ${fillRule}
  `
}

const propsToCss = ({
  size,
  sizes,
  fillColor,
  fillColorRule,
  noStyles
}) => getCss(size, sizes, fillColor, fillColorRule, noStyles)

const Image = styled.svg`${propsToCss}`

const children = (
  <Fragment>
    <defs
      key='key-0'
    >
      <linearGradient
        id='s-22d4241c82-a'
        x1='-2594.49'
        x2='-2594.24'
        y1='342.78'
        y2='342.78'
        gradientTransform='matrix(-1 0 0 1 -2383.04 -270.72)'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#595959'
        />
        <stop
          offset='.5'
          stopColor='#949494'
        />
        <stop
          offset='1'
          stopColor='#5c5c5c'
        />
      </linearGradient>
      <linearGradient
        id='s-22d4241c82-m'
        x1='-2593.3'
        x2='-2593.05'
        y1='342.73'
        y2='342.73'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-n'
        x1='-2592.19'
        x2='-2591.94'
        y1='342.67'
        y2='342.67'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-o'
        x1='-2591.08'
        x2='-2590.83'
        y1='342.59'
        y2='342.59'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-p'
        x1='-2589.89'
        x2='-2589.64'
        y1='342.52'
        y2='342.52'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-q'
        x1='-2588.78'
        x2='-2588.53'
        y1='342.45'
        y2='342.45'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-r'
        x1='-2587.66'
        x2='-2587.41'
        y1='342.39'
        y2='342.39'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-s'
        x1='-2586.47'
        x2='-2586.22'
        y1='342.31'
        y2='342.31'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-t'
        x1='-2585.36'
        x2='-2585.11'
        y1='342.25'
        y2='342.25'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-u'
        x1='-2584.25'
        x2='-2584'
        y1='342.19'
        y2='342.19'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-v'
        x1='-2583.06'
        x2='-2582.81'
        y1='342.15'
        y2='342.15'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-w'
        x1='-2581.95'
        x2='-2581.7'
        y1='342.03'
        y2='342.03'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-x'
        x1='-2580.87'
        x2='-2580.62'
        y1='341.96'
        y2='341.96'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-y'
        x1='-2579.68'
        x2='-2579.43'
        y1='341.93'
        y2='341.93'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-z'
        x1='-2578.57'
        x2='-2578.32'
        y1='341.86'
        y2='341.86'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-A'
        x1='-2599.32'
        x2='-2583.04'
        y1='332.51'
        y2='332.51'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-B'
        x1='-2599.31'
        x2='-2583.03'
        y1='331.05'
        y2='331.05'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-C'
        x1='-2599.3'
        x2='-2583.03'
        y1='329.67'
        y2='329.67'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-D'
        x1='-2599.3'
        x2='-2583.02'
        y1='328.22'
        y2='328.22'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-E'
        x1='-2599.29'
        x2='-2583.02'
        y1='326.84'
        y2='326.84'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-F'
        x1='-2599.43'
        x2='-2583.15'
        y1='362.2'
        y2='362.2'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-G'
        x1='-2599.43'
        x2='-2583.15'
        y1='363.4'
        y2='363.4'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-H'
        x1='-2599.42'
        x2='-2583.14'
        y1='360.82'
        y2='360.82'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-I'
        x1='-2599.42'
        x2='-2583.14'
        y1='359.36'
        y2='359.36'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-J'
        x1='-2599.41'
        x2='-2583.13'
        y1='357.98'
        y2='357.98'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-K'
        x1='-2599.4'
        x2='-2583.13'
        y1='356.53'
        y2='356.53'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-L'
        x1='-2599.4'
        x2='-2583.12'
        y1='355.15'
        y2='355.15'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-M'
        x1='-2599.39'
        x2='-2583.12'
        y1='353.69'
        y2='353.69'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-N'
        x1='-2599.39'
        x2='-2583.11'
        y1='352.31'
        y2='352.31'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-O'
        x1='-2599.38'
        x2='-2583.11'
        y1='350.86'
        y2='350.86'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-P'
        x1='-2599.38'
        x2='-2583.1'
        y1='349.44'
        y2='349.44'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-Q'
        x1='-2599.37'
        x2='-2583.1'
        y1='347.98'
        y2='347.98'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-R'
        x1='-2599.37'
        x2='-2583.09'
        y1='346.6'
        y2='346.6'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-S'
        x1='-2599.36'
        x2='-2583.09'
        y1='345.15'
        y2='345.15'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-T'
        x1='-2599.36'
        x2='-2583.08'
        y1='343.77'
        y2='343.77'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-U'
        x1='-2599.35'
        x2='-2583.07'
        y1='342.31'
        y2='342.31'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-V'
        x1='-2599.35'
        x2='-2583.07'
        y1='340.93'
        y2='340.93'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-W'
        x1='-2599.34'
        x2='-2583.06'
        y1='339.48'
        y2='339.48'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-X'
        x1='-2599.34'
        x2='-2583.06'
        y1='338.1'
        y2='338.1'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-Y'
        x1='-2599.33'
        x2='-2583.05'
        y1='336.64'
        y2='336.64'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-Z'
        x1='-2599.33'
        x2='-2583.05'
        y1='335.26'
        y2='335.26'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-aa'
        x1='-2599.32'
        x2='-2583.04'
        y1='333.81'
        y2='333.81'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-ab'
        x1='193.8'
        x2='212.91'
        y1='71.04'
        y2='71.04'
        xlinkHref='#s-22d4241c82-a'
      />
      <radialGradient
        id='s-22d4241c82-b'
        cx='197.22'
        cy='67.78'
        r='1.36'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#999'
        />
        <stop
          offset='1'
          stopColor='#4d4d4d'
        />
      </radialGradient>
      <linearGradient
        id='s-22d4241c82-c'
        x1='440.1'
        x2='440.12'
        y1='338.02'
        y2='337.5'
        gradientTransform='matrix(1.11 .01 .01 1 -291.37 -272.24)'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#4d4d4d'
        />
        <stop
          offset='.5'
          stopColor='#949494'
        />
        <stop
          offset='1'
          stopColor='#4d4d4d'
        />
      </linearGradient>
      <linearGradient
        id='s-22d4241c82-ac'
        x1='-2586.3'
        x2='-2584.3'
        y1='348.52'
        y2='348.52'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-ad'
        x1='-2596.2'
        x2='-2595.95'
        y1='348.58'
        y2='348.58'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-ae'
        x1='-2595.23'
        x2='-2594.98'
        y1='348.51'
        y2='348.51'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-af'
        x1='-2594.31'
        x2='-2594.06'
        y1='348.45'
        y2='348.45'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-ag'
        x1='-2593.4'
        x2='-2593.15'
        y1='348.4'
        y2='348.4'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-ah'
        x1='-2592.42'
        x2='-2592.17'
        y1='348.33'
        y2='348.33'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-ai'
        x1='-2591.5'
        x2='-2591.25'
        y1='348.27'
        y2='348.27'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-aj'
        x1='-2590.62'
        x2='-2590.37'
        y1='348.19'
        y2='348.19'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-ak'
        x1='-2589.64'
        x2='-2589.39'
        y1='348.06'
        y2='348.06'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-al'
        x1='-2602.73'
        x2='-2602.48'
        y1='348.98'
        y2='348.98'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-am'
        x1='-2601.81'
        x2='-2601.56'
        y1='348.92'
        y2='348.92'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-an'
        x1='-2600.9'
        x2='-2600.65'
        y1='348.87'
        y2='348.87'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-ao'
        x1='-2599.92'
        x2='-2599.67'
        y1='348.8'
        y2='348.8'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-ap'
        x1='-2599'
        x2='-2598.75'
        y1='348.75'
        y2='348.75'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-aq'
        x1='-2598.12'
        x2='-2597.87'
        y1='348.66'
        y2='348.66'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-ar'
        x1='-2597.14'
        x2='-2596.89'
        y1='348.53'
        y2='348.53'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-as'
        x1='-2588.72'
        x2='-2588.47'
        y1='348.02'
        y2='348.02'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-at'
        x1='-2587.81'
        x2='-2587.56'
        y1='347.95'
        y2='347.95'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-au'
        x1='-2608.17'
        x2='-2591.52'
        y1='341.5'
        y2='341.5'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-av'
        x1='-2608.16'
        x2='-2591.6'
        y1='340.62'
        y2='340.62'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-aw'
        x1='-2608.13'
        x2='-2591.59'
        y1='339.94'
        y2='339.94'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-ax'
        x1='-2608.17'
        x2='-2591.52'
        y1='342.24'
        y2='342.24'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-ay'
        x1='-2608.17'
        x2='-2591.52'
        y1='342.94'
        y2='342.94'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-az'
        x1='-2608.18'
        x2='-2591.53'
        y1='343.63'
        y2='343.63'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-aA'
        x1='-2608.18'
        x2='-2591.53'
        y1='344.35'
        y2='344.35'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-aB'
        x1='-2608.18'
        x2='-2591.53'
        y1='345.1'
        y2='345.1'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-aC'
        x1='-2608.18'
        x2='-2591.53'
        y1='345.79'
        y2='345.79'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-aD'
        x1='-2608.19'
        x2='-2591.54'
        y1='346.48'
        y2='346.48'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-aE'
        x1='-2608.19'
        x2='-2591.54'
        y1='347.23'
        y2='347.23'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-aF'
        x1='-2608.19'
        x2='-2591.54'
        y1='347.98'
        y2='347.98'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-aG'
        x1='-2608.19'
        x2='-2591.54'
        y1='348.67'
        y2='348.67'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-aH'
        x1='-2608.2'
        x2='-2591.55'
        y1='349.36'
        y2='349.36'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-aI'
        x1='-2608.2'
        x2='-2591.55'
        y1='350.09'
        y2='350.09'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-aJ'
        x1='-2608.2'
        x2='-2591.55'
        y1='350.83'
        y2='350.83'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-aK'
        x1='-2608.2'
        x2='-2591.55'
        y1='351.53'
        y2='351.53'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-aL'
        x1='-2608.21'
        x2='-2591.56'
        y1='352.22'
        y2='352.22'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-aM'
        x1='-2608.21'
        x2='-2591.56'
        y1='352.91'
        y2='352.91'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-aN'
        x1='-2608.21'
        x2='-2591.56'
        y1='353.66'
        y2='353.66'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-aO'
        x1='-2608.22'
        x2='-2591.56'
        y1='354.36'
        y2='354.36'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-aP'
        x1='-2608.22'
        x2='-2591.57'
        y1='355.04'
        y2='355.04'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-aQ'
        x1='-2608.22'
        x2='-2591.57'
        y1='355.77'
        y2='355.77'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-aR'
        x1='-2608.22'
        x2='-2591.57'
        y1='356.52'
        y2='356.52'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-aS'
        x1='-2608.23'
        x2='-2591.58'
        y1='357.21'
        y2='357.21'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-aT'
        x1='-2608.23'
        x2='-2591.58'
        y1='357.9'
        y2='357.9'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-aU'
        x1='-2608.23'
        x2='-2591.58'
        y1='358.65'
        y2='358.65'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-aV'
        x1='-2608.23'
        x2='-2591.58'
        y1='359.39'
        y2='359.39'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-aW'
        x1='-2608.24'
        x2='-2591.59'
        y1='360.09'
        y2='360.09'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-aX'
        x1='-2608.24'
        x2='-2591.59'
        y1='360.78'
        y2='360.78'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-aY'
        x1='-2608.24'
        x2='-2591.59'
        y1='361.5'
        y2='361.5'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-aZ'
        x1='-2608.24'
        x2='-2591.59'
        y1='362.22'
        y2='362.22'
        gradientTransform='matrix(-.99 0 0 1 -2370.02 -263.2)'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-ba'
        x1='481.62'
        x2='460.05'
        y1='340.14'
        y2='356.66'
        xlinkHref='#s-22d4241c82-a'
      />
      <linearGradient
        id='s-22d4241c82-bb'
        x1='-2605.94'
        x2='-2603.94'
        y1='349.62'
        y2='349.62'
        xlinkHref='#s-22d4241c82-a'
      />
      <radialGradient
        id='s-22d4241c82-bc'
        cx='206.4'
        cy='77.37'
        r='1.12'
        xlinkHref='#s-22d4241c82-b'
      />
      <linearGradient
        id='s-22d4241c82-bd'
        x1='448.06'
        x2='448.09'
        y1='347.55'
        y2='347.03'
        xlinkHref='#s-22d4241c82-c'
      />
      <linearGradient
        id='s-22d4241c82-d'
        x1='541.69'
        x2='548.82'
        y1='325.49'
        y2='324.49'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#525252'
        />
        <stop
          offset='.01'
          stopColor='#545454'
        />
        <stop
          offset='.23'
          stopColor='#818181'
        />
        <stop
          offset='.4'
          stopColor='#9e9e9e'
        />
        <stop
          offset='.5'
          stopColor='#a8a8a8'
        />
        <stop
          offset='.59'
          stopColor='#a2a2a2'
        />
        <stop
          offset='.72'
          stopColor='#909090'
        />
        <stop
          offset='.87'
          stopColor='#737373'
        />
        <stop
          offset='1'
          stopColor='#525252'
        />
      </linearGradient>
      <linearGradient
        id='s-22d4241c82-be'
        x1='549.56'
        x2='557.58'
        y1='325.74'
        y2='324.61'
        xlinkHref='#s-22d4241c82-d'
      />
      <linearGradient
        id='s-22d4241c82-e'
        x1='277.11'
        x2='277.42'
        y1='48.93'
        y2='48.93'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#c2c2c2'
        />
        <stop
          offset='1'
          stopColor='#757575'
        />
      </linearGradient>
      <linearGradient
        id='s-22d4241c82-bf'
        x1='277.79'
        x2='278.1'
        y1='48.96'
        y2='48.96'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-bg'
        x1='278.44'
        x2='278.75'
        y1='48.99'
        y2='48.99'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-bh'
        x1='279.12'
        x2='279.42'
        y1='49.04'
        y2='49.04'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-bi'
        x1='279.77'
        x2='280.08'
        y1='49.11'
        y2='49.11'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-bj'
        x1='280.45'
        x2='280.76'
        y1='49.14'
        y2='49.14'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-bk'
        x1='281.1'
        x2='281.41'
        y1='49.17'
        y2='49.17'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-bl'
        x1='281.78'
        x2='282.08'
        y1='49.21'
        y2='49.21'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-bm'
        x1='282.42'
        x2='282.72'
        y1='49.24'
        y2='49.24'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-bn'
        x1='283.09'
        x2='283.4'
        y1='49.27'
        y2='49.27'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-bo'
        x1='283.74'
        x2='284.05'
        y1='49.3'
        y2='49.3'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-bp'
        x1='284.42'
        x2='284.73'
        y1='49.35'
        y2='49.35'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-bq'
        x1='285.08'
        x2='285.38'
        y1='49.42'
        y2='49.42'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-br'
        x1='285.75'
        x2='286.06'
        y1='49.44'
        y2='49.44'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-bs'
        x1='286.4'
        x2='286.71'
        y1='49.48'
        y2='49.48'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-bt'
        x1='287.08'
        x2='287.39'
        y1='49.52'
        y2='49.52'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-bu'
        x1='287.78'
        x2='288.08'
        y1='49.57'
        y2='49.57'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-bv'
        x1='288.45'
        x2='288.76'
        y1='49.6'
        y2='49.6'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-bw'
        x1='289.1'
        x2='289.41'
        y1='49.63'
        y2='49.63'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-bx'
        x1='289.78'
        x2='290.08'
        y1='49.67'
        y2='49.67'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-by'
        x1='290.44'
        x2='290.74'
        y1='49.74'
        y2='49.74'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-bz'
        x1='291.11'
        x2='291.42'
        y1='49.77'
        y2='49.77'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-bA'
        x1='291.76'
        x2='292.07'
        y1='49.8'
        y2='49.8'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-bB'
        x1='292.44'
        x2='292.75'
        y1='49.84'
        y2='49.84'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-bC'
        x1='293.08'
        x2='293.38'
        y1='49.88'
        y2='49.88'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-bD'
        x1='293.76'
        x2='294.06'
        y1='49.9'
        y2='49.9'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-bE'
        x1='294.41'
        x2='294.71'
        y1='49.94'
        y2='49.94'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-bF'
        x1='295.08'
        x2='295.39'
        y1='49.98'
        y2='49.98'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-bG'
        x1='295.74'
        x2='296.04'
        y1='50.05'
        y2='50.05'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-bH'
        x1='296.42'
        x2='296.72'
        y1='50.08'
        y2='50.08'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-bI'
        x1='297.07'
        x2='297.37'
        y1='50.11'
        y2='50.11'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-bJ'
        x1='297.74'
        x2='298.05'
        y1='50.15'
        y2='50.15'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-bK'
        x1='298.37'
        x2='298.68'
        y1='50.15'
        y2='50.15'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-bL'
        x1='299.02'
        x2='299.33'
        y1='50.18'
        y2='50.18'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-bM'
        x1='299.7'
        x2='300'
        y1='50.23'
        y2='50.23'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-bN'
        x1='300.36'
        x2='300.66'
        y1='50.3'
        y2='50.3'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-bO'
        x1='301.03'
        x2='301.34'
        y1='50.33'
        y2='50.33'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-bP'
        x1='301.68'
        x2='301.99'
        y1='50.36'
        y2='50.36'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-bQ'
        x1='302.36'
        x2='302.66'
        y1='50.4'
        y2='50.4'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-bR'
        x1='535.16'
        x2='562.34'
        y1='313.75'
        y2='313.75'
        gradientTransform='rotate(86.78 548.746 313.742)'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-bS'
        x1='535.16'
        x2='562.34'
        y1='313.06'
        y2='313.06'
        gradientTransform='rotate(86.78 548.75 313.058)'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-bT'
        x1='535.16'
        x2='562.34'
        y1='315.12'
        y2='315.12'
        gradientTransform='rotate(86.78 548.743 315.117)'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-bU'
        x1='535.16'
        x2='562.34'
        y1='314.43'
        y2='314.43'
        gradientTransform='rotate(86.78 548.747 314.432)'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-bV'
        x1='535.16'
        x2='562.34'
        y1='316.57'
        y2='316.57'
        gradientTransform='rotate(86.78 548.749 316.574)'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-bW'
        x1='535.16'
        x2='562.34'
        y1='315.88'
        y2='315.88'
        gradientTransform='rotate(86.78 548.747 315.884)'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-bX'
        x1='535.16'
        x2='562.34'
        y1='317.94'
        y2='317.94'
        gradientTransform='rotate(86.78 548.746 317.939)'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-bY'
        x1='535.16'
        x2='562.34'
        y1='317.26'
        y2='317.26'
        gradientTransform='rotate(86.78 548.745 317.259)'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-bZ'
        x1='535.16'
        x2='562.34'
        y1='319.39'
        y2='319.39'
        gradientTransform='rotate(86.78 548.747 319.39)'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-ca'
        x1='535.16'
        x2='562.34'
        y1='318.7'
        y2='318.7'
        gradientTransform='rotate(86.78 548.746 318.7)'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-cb'
        x1='535.16'
        x2='562.34'
        y1='320.77'
        y2='320.77'
        gradientTransform='rotate(86.78 548.744 320.765)'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-cc'
        x1='535.16'
        x2='562.34'
        y1='320.08'
        y2='320.08'
        gradientTransform='rotate(86.78 548.748 320.08)'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-cd'
        x1='535.16'
        x2='562.34'
        y1='322.22'
        y2='322.22'
        gradientTransform='rotate(86.78 548.745 322.217)'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-ce'
        x1='535.16'
        x2='562.34'
        y1='321.53'
        y2='321.53'
        gradientTransform='rotate(86.78 548.748 321.532)'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-cf'
        x1='535.16'
        x2='562.34'
        y1='322.9'
        y2='322.9'
        gradientTransform='rotate(86.78 548.746 322.897)'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-cg'
        x1='535.16'
        x2='562.34'
        y1='324.36'
        y2='324.36'
        gradientTransform='rotate(86.78 548.746 324.359)'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-ch'
        x1='535.16'
        x2='562.34'
        y1='323.67'
        y2='323.67'
        gradientTransform='rotate(86.78 548.745 323.67)'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-ci'
        x1='535.16'
        x2='562.34'
        y1='325.73'
        y2='325.73'
        gradientTransform='rotate(86.78 548.744 325.723)'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-cj'
        x1='535.16'
        x2='562.34'
        y1='325.04'
        y2='325.04'
        gradientTransform='rotate(86.78 548.742 325.044)'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-ck'
        x1='535.16'
        x2='562.34'
        y1='327.18'
        y2='327.18'
        gradientTransform='rotate(86.78 548.75 327.18)'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-cl'
        x1='535.16'
        x2='562.34'
        y1='326.49'
        y2='326.49'
        gradientTransform='rotate(86.78 548.743 326.496)'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-cm'
        x1='535.16'
        x2='562.34'
        y1='327.87'
        y2='327.87'
        gradientTransform='rotate(86.78 548.745 327.865)'
        xlinkHref='#s-22d4241c82-e'
      />
      <linearGradient
        id='s-22d4241c82-f'
        x1='548.75'
        x2='548.75'
        y1='329.54'
        y2='311.13'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#4d4d4d'
        />
        <stop
          offset='.12'
          stopColor='#5b5b5b'
        />
        <stop
          offset='.35'
          stopColor='#6f6f6f'
        />
        <stop
          offset='.58'
          stopColor='#7c7c7c'
        />
        <stop
          offset='.81'
          stopColor='gray'
        />
        <stop
          offset='1'
          stopColor='#b3b3b3'
        />
      </linearGradient>
      <linearGradient
        id='s-22d4241c82-cn'
        x1='548.33'
        x2='548.33'
        y1='326.64'
        y2='317.62'
        xlinkHref='#s-22d4241c82-f'
      />
      <linearGradient
        id='s-22d4241c82-g'
        x1='1968.26'
        x2='1968.21'
        y1='749.37'
        y2='749.62'
        gradientTransform='rotate(-27.38 391.605 3461.088)'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#949494'
        />
        <stop
          offset='1'
          stopColor='#454545'
        />
      </linearGradient>
      <linearGradient
        id='s-22d4241c82-co'
        x1='726.42'
        x2='726.08'
        y1='1005.5'
        y2='1004.91'
        gradientTransform='matrix(-.28 -1.17 .81 -.19 -66.1 1371.56)'
        xlinkHref='#s-22d4241c82-g'
      />
      <radialGradient
        id='s-22d4241c82-cp'
        cx='-1471.8'
        cy='581.84'
        r='4.12'
        gradientTransform='matrix(-1 .02 .03 .64 -944.07 -14.8)'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='.46'
          stopColor='#d1d1d1'
        />
        <stop
          offset='1'
          stopColor='#969696'
        />
      </radialGradient>
      <linearGradient
        id='s-22d4241c82-h'
        x1='121.39'
        x2='121.39'
        y1='121.13'
        y2='144.77'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#4d4d4d'
        />
        <stop
          offset='1'
          stopColor='#666'
        />
      </linearGradient>
      <linearGradient
        id='s-22d4241c82-i'
        x1='95.62'
        x2='147.95'
        y1='132.08'
        y2='132.08'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#666'
        />
        <stop
          offset='1'
          stopColor='#999'
        />
      </linearGradient>
      <linearGradient
        id='s-22d4241c82-cq'
        x1='398.69'
        x2='398.69'
        y1='392.56'
        y2='361.63'
        xlinkHref='#s-22d4241c82-f'
      />
      <linearGradient
        id='s-22d4241c82-cr'
        x1='399.8'
        x2='399.8'
        y1='392.7'
        y2='364.57'
        xlinkHref='#s-22d4241c82-f'
      />
      <linearGradient
        id='s-22d4241c82-cs'
        x1='400.88'
        x2='400.88'
        y1='392.84'
        y2='367.41'
        xlinkHref='#s-22d4241c82-f'
      />
      <linearGradient
        id='s-22d4241c82-ct'
        x1='401.97'
        x2='401.97'
        y1='392.98'
        y2='370.78'
        xlinkHref='#s-22d4241c82-f'
      />
      <linearGradient
        id='s-22d4241c82-cu'
        x1='403.05'
        x2='403.05'
        y1='393.11'
        y2='373.4'
        xlinkHref='#s-22d4241c82-f'
      />
      <linearGradient
        id='s-22d4241c82-cv'
        x1='404.17'
        x2='404.17'
        y1='393.24'
        y2='376.38'
        xlinkHref='#s-22d4241c82-f'
      />
      <linearGradient
        id='s-22d4241c82-cw'
        x1='397.31'
        x2='397.31'
        y1='392.46'
        y2='358.98'
        xlinkHref='#s-22d4241c82-f'
      />
      <linearGradient
        id='s-22d4241c82-cx'
        x1='394.81'
        x2='394.81'
        y1='393.97'
        y2='360.49'
        xlinkHref='#s-22d4241c82-f'
      />
      <linearGradient
        id='s-22d4241c82-cy'
        x1='392.31'
        x2='392.31'
        y1='395.37'
        y2='361.88'
        xlinkHref='#s-22d4241c82-f'
      />
      <linearGradient
        id='s-22d4241c82-cz'
        x1='389.81'
        x2='389.81'
        y1='396.96'
        y2='363.48'
        xlinkHref='#s-22d4241c82-f'
      />
      <linearGradient
        id='s-22d4241c82-cA'
        x1='387.09'
        x2='387.09'
        y1='398.57'
        y2='365.08'
        xlinkHref='#s-22d4241c82-f'
      />
      <linearGradient
        id='s-22d4241c82-cB'
        x1='384.6'
        x2='384.6'
        y1='400.08'
        y2='366.59'
        xlinkHref='#s-22d4241c82-f'
      />
      <linearGradient
        id='s-22d4241c82-cC'
        x1='382.1'
        x2='382.1'
        y1='401.47'
        y2='367.99'
        xlinkHref='#s-22d4241c82-f'
      />
      <linearGradient
        id='s-22d4241c82-cD'
        x1='379.6'
        x2='379.6'
        y1='403.06'
        y2='369.58'
        xlinkHref='#s-22d4241c82-f'
      />
      <linearGradient
        id='s-22d4241c82-cE'
        x1='377.17'
        x2='377.17'
        y1='404.63'
        y2='371.15'
        xlinkHref='#s-22d4241c82-f'
      />
      <linearGradient
        id='s-22d4241c82-cF'
        x1='374.68'
        x2='374.68'
        y1='406.14'
        y2='372.66'
        xlinkHref='#s-22d4241c82-f'
      />
      <linearGradient
        id='s-22d4241c82-cG'
        x1='372.18'
        x2='372.18'
        y1='407.54'
        y2='374.06'
        xlinkHref='#s-22d4241c82-f'
      />
      <linearGradient
        id='s-22d4241c82-cH'
        x1='369.68'
        x2='369.68'
        y1='409.13'
        y2='375.65'
        xlinkHref='#s-22d4241c82-f'
      />
      <linearGradient
        id='s-22d4241c82-cI'
        x1='367.11'
        x2='367.11'
        y1='410.65'
        y2='377.16'
        xlinkHref='#s-22d4241c82-f'
      />
      <linearGradient
        id='s-22d4241c82-cJ'
        x1='364.82'
        x2='364.82'
        y1='412.11'
        y2='378.63'
        xlinkHref='#s-22d4241c82-f'
      />
      <linearGradient
        id='s-22d4241c82-cK'
        x1='366.22'
        x2='366.22'
        y1='412.29'
        y2='381.35'
        xlinkHref='#s-22d4241c82-f'
      />
      <linearGradient
        id='s-22d4241c82-cL'
        x1='367.33'
        x2='367.33'
        y1='412.43'
        y2='384.3'
        xlinkHref='#s-22d4241c82-f'
      />
      <linearGradient
        id='s-22d4241c82-cM'
        x1='368.42'
        x2='368.42'
        y1='412.56'
        y2='387.14'
        xlinkHref='#s-22d4241c82-f'
      />
      <linearGradient
        id='s-22d4241c82-cN'
        x1='369.5'
        x2='369.5'
        y1='412.7'
        y2='390.5'
        xlinkHref='#s-22d4241c82-f'
      />
      <linearGradient
        id='s-22d4241c82-cO'
        x1='370.59'
        x2='370.59'
        y1='412.84'
        y2='393.12'
        xlinkHref='#s-22d4241c82-f'
      />
      <linearGradient
        id='s-22d4241c82-cP'
        x1='371.7'
        x2='371.7'
        y1='412.97'
        y2='396.11'
        xlinkHref='#s-22d4241c82-f'
      />
      <linearGradient
        id='s-22d4241c82-cQ'
        x1='148.66'
        x2='113.1'
        y1='115.81'
        y2='115.81'
        xlinkHref='#s-22d4241c82-h'
      />
      <linearGradient
        id='s-22d4241c82-j'
        x1='131.62'
        x2='131.62'
        y1='144.77'
        y2='87.68'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='gray'
        />
        <stop
          offset='1'
          stopColor='#b3b3b3'
        />
      </linearGradient>
      <linearGradient
        id='s-22d4241c82-cR'
        x1='400.24'
        x2='400.24'
        y1='355.68'
        y2='355.68'
        xlinkHref='#s-22d4241c82-h'
      />
      <linearGradient
        id='s-22d4241c82-cS'
        x1='-1107'
        x2='-1107'
        y1='413.51'
        y2='444.07'
        gradientTransform='matrix(-1 0 0 1 -677.76 -270.72)'
        xlinkHref='#s-22d4241c82-h'
      />
      <linearGradient
        id='s-22d4241c82-cT'
        x1='-1119.98'
        x2='-1093.25'
        y1='427.52'
        y2='427.52'
        gradientTransform='matrix(-1 0 0 1 -677.76 -270.72)'
        xlinkHref='#s-22d4241c82-i'
      />
      <linearGradient
        id='s-22d4241c82-cU'
        x1='-1126.8'
        x2='-1126.8'
        y1='324.22'
        y2='294.62'
        gradientTransform='matrix(-1.01 -.11 -.11 .99 -420.1 -32.35)'
        xlinkHref='#s-22d4241c82-f'
      />
      <linearGradient
        id='s-22d4241c82-cV'
        x1='-1125.97'
        x2='-1125.97'
        y1='324.35'
        y2='297.45'
        gradientTransform='matrix(-1.01 -.11 -.11 .99 -420.1 -32.35)'
        xlinkHref='#s-22d4241c82-f'
      />
      <linearGradient
        id='s-22d4241c82-cW'
        x1='-1125.07'
        x2='-1125.07'
        y1='324.49'
        y2='300.17'
        gradientTransform='matrix(-1.01 -.11 -.11 .99 -420.1 -32.35)'
        xlinkHref='#s-22d4241c82-f'
      />
      <linearGradient
        id='s-22d4241c82-cX'
        x1='-1124.2'
        x2='-1124.2'
        y1='324.62'
        y2='303.4'
        gradientTransform='matrix(-1.01 -.11 -.11 .99 -420.1 -32.35)'
        xlinkHref='#s-22d4241c82-f'
      />
      <linearGradient
        id='s-22d4241c82-cY'
        x1='-1123.3'
        x2='-1123.3'
        y1='324.75'
        y2='305.95'
        gradientTransform='matrix(-1.01 -.11 -.11 .99 -420.1 -32.35)'
        xlinkHref='#s-22d4241c82-f'
      />
      <linearGradient
        id='s-22d4241c82-cZ'
        x1='-1122.36'
        x2='-1122.36'
        y1='324.88'
        y2='308.78'
        gradientTransform='matrix(-1.01 -.11 -.11 .99 -420.1 -32.35)'
        xlinkHref='#s-22d4241c82-f'
      />
      <linearGradient
        id='s-22d4241c82-da'
        x1='-1127.84'
        x2='-1127.84'
        y1='323.95'
        y2='292.22'
        gradientTransform='matrix(-1.01 -.11 -.11 .99 -420.1 -32.35)'
        xlinkHref='#s-22d4241c82-f'
      />
      <linearGradient
        id='s-22d4241c82-db'
        x1='-1128.86'
        x2='-1128.86'
        y1='326.11'
        y2='294.39'
        gradientTransform='matrix(-1.01 -.11 -.11 .99 -420.1 -32.35)'
        xlinkHref='#s-22d4241c82-f'
      />
      <linearGradient
        id='s-22d4241c82-dc'
        x1='-1129.85'
        x2='-1129.85'
        y1='328.15'
        y2='296.43'
        gradientTransform='matrix(-1.01 -.11 -.11 .99 -420.1 -32.35)'
        xlinkHref='#s-22d4241c82-f'
      />
      <linearGradient
        id='s-22d4241c82-dd'
        x1='-1130.96'
        x2='-1130.96'
        y1='330.73'
        y2='299'
        gradientTransform='matrix(-1.01 -.11 -.11 .99 -420.1 -32.35)'
        xlinkHref='#s-22d4241c82-f'
      />
      <linearGradient
        id='s-22d4241c82-de'
        x1='-1131.9'
        x2='-1131.9'
        y1='332.54'
        y2='300.82'
        gradientTransform='matrix(-1.01 -.11 -.11 .99 -420.1 -32.35)'
        xlinkHref='#s-22d4241c82-f'
      />
      <linearGradient
        id='s-22d4241c82-df'
        x1='-1132.89'
        x2='-1132.89'
        y1='334.68'
        y2='302.95'
        gradientTransform='matrix(-1.01 -.11 -.11 .99 -420.1 -32.35)'
        xlinkHref='#s-22d4241c82-f'
      />
      <linearGradient
        id='s-22d4241c82-dg'
        x1='-1133.9'
        x2='-1133.9'
        y1='336.82'
        y2='305.09'
        gradientTransform='matrix(-1.01 -.11 -.11 .99 -420.1 -32.35)'
        xlinkHref='#s-22d4241c82-f'
      />
      <linearGradient
        id='s-22d4241c82-dh'
        x1='-1135.01'
        x2='-1135.01'
        y1='339.41'
        y2='307.68'
        gradientTransform='matrix(-1.01 -.11 -.11 .99 -420.1 -32.35)'
        xlinkHref='#s-22d4241c82-f'
      />
      <linearGradient
        id='s-22d4241c82-di'
        x1='-1136.06'
        x2='-1136.06'
        y1='341.67'
        y2='309.94'
        gradientTransform='matrix(-1.01 -.11 -.11 .99 -420.1 -32.35)'
        xlinkHref='#s-22d4241c82-f'
      />
      <linearGradient
        id='s-22d4241c82-dj'
        x1='-1137.09'
        x2='-1137.09'
        y1='343.96'
        y2='312.23'
        gradientTransform='matrix(-1.01 -.11 -.11 .99 -420.1 -32.35)'
        xlinkHref='#s-22d4241c82-f'
      />
      <linearGradient
        id='s-22d4241c82-dk'
        x1='-1138.13'
        x2='-1138.13'
        y1='346.25'
        y2='314.52'
        gradientTransform='matrix(-1.01 -.11 -.11 .99 -420.1 -32.35)'
        xlinkHref='#s-22d4241c82-f'
      />
      <linearGradient
        id='s-22d4241c82-dl'
        x1='-1139.01'
        x2='-1139.01'
        y1='347.66'
        y2='317.32'
        gradientTransform='matrix(-1.01 -.11 -.11 .99 -420.1 -32.35)'
        xlinkHref='#s-22d4241c82-f'
      />
      <linearGradient
        id='s-22d4241c82-dm'
        x1='-1139.84'
        x2='-1139.84'
        y1='349.27'
        y2='319.43'
        gradientTransform='matrix(-1.01 -.11 -.11 .99 -420.1 -32.35)'
        xlinkHref='#s-22d4241c82-f'
      />
      <linearGradient
        id='s-22d4241c82-dn'
        x1='-1140.37'
        x2='-1140.37'
        y1='350.29'
        y2='321.96'
        gradientTransform='matrix(-1.01 -.11 -.11 .99 -420.1 -32.35)'
        xlinkHref='#s-22d4241c82-f'
      />
      <linearGradient
        id='s-22d4241c82-do'
        x1='-1139.52'
        x2='-1139.52'
        y1='350.6'
        y2='324.3'
        gradientTransform='matrix(-1.01 -.11 -.11 .99 -420.1 -32.35)'
        xlinkHref='#s-22d4241c82-f'
      />
      <linearGradient
        id='s-22d4241c82-dp'
        x1='-1138.68'
        x2='-1138.68'
        y1='350.87'
        y2='327.13'
        gradientTransform='matrix(-1.01 -.11 -.11 .99 -420.1 -32.35)'
        xlinkHref='#s-22d4241c82-f'
      />
      <linearGradient
        id='s-22d4241c82-dq'
        x1='-1137.56'
        x2='-1137.56'
        y1='350.93'
        y2='329.86'
        gradientTransform='matrix(-1.01 -.11 -.11 .99 -420.1 -32.35)'
        xlinkHref='#s-22d4241c82-f'
      />
      <linearGradient
        id='s-22d4241c82-dr'
        x1='-1136.59'
        x2='-1136.59'
        y1='351.15'
        y2='333.09'
        gradientTransform='matrix(-1.01 -.11 -.11 .99 -420.1 -32.35)'
        xlinkHref='#s-22d4241c82-f'
      />
      <linearGradient
        id='s-22d4241c82-ds'
        x1='-1135.63'
        x2='-1135.63'
        y1='351.28'
        y2='335.63'
        gradientTransform='matrix(-1.01 -.11 -.11 .99 -420.1 -32.35)'
        xlinkHref='#s-22d4241c82-f'
      />
      <linearGradient
        id='s-22d4241c82-dt'
        x1='-1134.7'
        x2='-1134.7'
        y1='351.08'
        y2='338.47'
        gradientTransform='matrix(-1.01 -.11 -.11 .99 -420.1 -32.35)'
        xlinkHref='#s-22d4241c82-f'
      />
      <linearGradient
        id='s-22d4241c82-du'
        x1='-1120.91'
        x2='-1132.39'
        y1='395.99'
        y2='395.99'
        gradientTransform='matrix(-1 .01 .01 1 -708.96 -246.63)'
        xlinkHref='#s-22d4241c82-h'
      />
      <linearGradient
        id='s-22d4241c82-dv'
        x1='-1125.94'
        x2='-1125.94'
        y1='427.23'
        y2='364.98'
        gradientTransform='matrix(-1 .01 .01 1 -708.96 -246.63)'
        xlinkHref='#s-22d4241c82-j'
      />
      <linearGradient
        id='s-22d4241c82-k'
        x1='285.07'
        x2='287.07'
        y1='94.39'
        y2='94.39'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#333'
        />
        <stop
          offset='.51'
          stopColor='#999'
        />
        <stop
          offset='1'
          stopColor='#333'
        />
      </linearGradient>
      <linearGradient
        id='s-22d4241c82-dw'
        x1='242.77'
        x2='281.93'
        y1='113.97'
        y2='113.97'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#e6e6e6'
        />
        <stop
          offset='1'
          stopColor='#f2f2f2'
        />
      </linearGradient>
      <linearGradient
        id='s-22d4241c82-dx'
        x1='234.4'
        x2='236.4'
        y1='162.25'
        y2='162.25'
        xlinkHref='#s-22d4241c82-k'
      />
      <linearGradient
        id='s-22d4241c82-l'
        x1='397.36'
        x2='397.36'
        y1='397.79'
        y2='412.52'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#c1272d'
        />
        <stop
          offset='.53'
          stopColor='#c6594b'
        />
        <stop
          offset='1'
          stopColor='#c1272d'
        />
      </linearGradient>
      <linearGradient
        id='s-22d4241c82-dy'
        x1='381.17'
        x2='414.04'
        y1='404.58'
        y2='404.58'
        xlinkHref='#s-22d4241c82-l'
      />
      <linearGradient
        id='s-22d4241c82-dz'
        x1='402.9'
        x2='413.86'
        y1='387.58'
        y2='387.58'
        xlinkHref='#s-22d4241c82-l'
      />
      <linearGradient
        id='s-22d4241c82-dA'
        x1='382.06'
        x2='393.02'
        y1='399.91'
        y2='399.91'
        xlinkHref='#s-22d4241c82-l'
      />
      <linearGradient
        id='s-22d4241c82-dB'
        x1='392.15'
        x2='414.47'
        y1='394.35'
        y2='394.35'
        xlinkHref='#s-22d4241c82-l'
      />
      <linearGradient
        id='s-22d4241c82-dC'
        x1='393.08'
        x2='414.48'
        y1='394.74'
        y2='394.74'
        xlinkHref='#s-22d4241c82-l'
      />
      <linearGradient
        id='s-22d4241c82-dD'
        x1='-1087.73'
        x2='-1087.73'
        y1='416.42'
        y2='436.87'
        gradientTransform='matrix(-1 0 0 1 -677.76 -270.72)'
        xlinkHref='#s-22d4241c82-l'
      />
      <linearGradient
        id='s-22d4241c82-dE'
        x1='-1095.85'
        x2='-1079.16'
        y1='425.91'
        y2='425.91'
        gradientTransform='matrix(-1 0 0 1 -677.76 -270.72)'
        xlinkHref='#s-22d4241c82-l'
      />
      <linearGradient
        id='s-22d4241c82-dF'
        x1='659.89'
        x2='670.34'
        y1='406.87'
        y2='406.87'
        xlinkHref='#s-22d4241c82-l'
      />
      <linearGradient
        id='s-22d4241c82-dG'
        x1='666.42'
        x2='676.58'
        y1='425.47'
        y2='425.47'
        xlinkHref='#s-22d4241c82-l'
      />
      <linearGradient
        id='s-22d4241c82-dH'
        x1='659.74'
        x2='666.74'
        y1='416.62'
        y2='416.62'
        xlinkHref='#s-22d4241c82-l'
      />
    </defs>
    <g
      id='surface'
    >
      <g
        id='mainSurface'
      >
        <path
          d='M464.88 232.42L1.61 197.35 183.63 88.72l236.06 14.31 45.19 129.39z'
          style={{
            fill: '#4d4d4d',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
        />
        <path
          d='M450.31 223.69L25.34 191.43l161.7-96.52 224.94 13.77 38.33 115.01z'
          style={{
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
        />
        <path
          d='M222.99 206.34l70.7-104.9'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
        />
      </g>
      <path
        id='surfaceBadminton'
        className='badminton'
        d='M424.01 190.07L82.49 165.71 168.56 113l237.58 14.71 17.87 62.36z'
        style={{
          fill: '#4ab9bc',
        }}
      />
      <path
        id='surfaceBasket'
        className='basketball'
        d='M312.63 130.17l-74.67-3.77 21.2-26.85 68.17 3.84-14.7 26.78z'
      />
    </g>
    <g
      id='lines'
    >
      <g
        id='basketballLines'
        className='basketball'
      >
        <path
          d='M450.27 366.61c-54.66 51.75 207.5 64.24 216.48 12.18'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
          transform='translate(-258.81 -270.72)'
        />
        <path
          d='M312.63 130.17l-74.67-3.77 21.2-26.85 68.17 3.84-14.7 26.78z'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
        />
        <path
          d='M571.45 400.89c-5.09 6.35-18.87 10.85-37.1 10.56-20.77-.34-40.84-5.23-37.6-14.58'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
          transform='translate(-258.81 -270.72)'
        />
      </g>
      <g
        id='badmintonLines'
        className='badminton'
      >
        <path
          d='M424.01 190.07L82.49 165.71 168.56 113l237.58 14.71 17.87 62.36zM242.67 177.13l39.52-57.1M132.89 134.78l89.61 6.2M310.64 146.62l102.84 6.72M294.25 180.81l27.95-58.3M196.85 173.87l44.62-56.49M394.19 126.97l11.53 61.8M98.71 166.86l81.24-53.15M89.74 161.27l332.69 23.29M163.94 115.83l243.08 14.93'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
        />
      </g>
    </g>
    <image
      id='high'
      width='1826'
      height='927'
      transform='translate(24.15) scale(.24)'
      xlinkHref={_14x151}
    />
    <image
      id='medium'
      width='1823'
      height='848'
      transform='matrix(.24 0 0 .24 24.39 17.04)'
      xlinkHref={_14x152}
    />
    <image
      id='small'
      width='1843'
      height='805'
      transform='matrix(.24 0 0 .24 19.83 29.52)'
      xlinkHref={_14x153}
    />
    <g
      id='wicket'
    >
      <path
        d='M212.41 90.84L194.3 89.8V51.37l18.11 1.05v38.42z'
        style={{
          fill: '#fff',
        }}
      />
      <path
        d='M212.18 62.54l-.85-.07V59.1l.85.07v3.37zM212.18 83.83l-.85-.07V80.4l.85.07v3.36z'
        style={{
          fill: '#999',
        }}
      />
      <path
        d='M211.33 53.9v36.33'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-a)',
        }}
      />
      <path
        d='M210.14 53.83v36.35'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-m)',
        }}
      />
      <path
        d='M209.03 53.78v36.34'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-n)',
        }}
      />
      <path
        d='M207.92 53.66v36.41'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-o)',
        }}
      />
      <path
        d='M206.73 53.59V90'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-p)',
        }}
      />
      <path
        d='M205.62 53.53v36.41'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-q)',
        }}
      />
      <path
        d='M204.5 53.47v36.4'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-r)',
        }}
      />
      <path
        d='M203.31 53.38v36.43'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-s)',
        }}
      />
      <path
        d='M202.2 53.32v36.42'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-t)',
        }}
      />
      <path
        d='M201.09 53.25v36.44'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-u)',
        }}
      />
      <path
        d='M199.9 53.25V89.6'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-v)',
        }}
      />
      <path
        d='M198.79 53.11v36.4'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-w)',
        }}
      />
      <path
        d='M197.71 53.07v36.34'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-x)',
        }}
      />
      <path
        d='M196.52 53.01v36.4'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-y)',
        }}
      />
      <path
        d='M195.41 52.94v36.41'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-z)',
        }}
      />
      <path
        d='M211.33 59.5l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-A)',
        }}
      />
      <path
        d='M211.33 58.05l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-B)',
        }}
      />
      <path
        d='M211.33 56.67l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-C)',
        }}
      />
      <path
        d='M211.33 55.22l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-D)',
        }}
      />
      <path
        d='M211.33 53.84l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-E)',
        }}
      />
      <path
        d='M211.33 89.13l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-F)',
        }}
      />
      <path
        d='M211.33 90.33l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-G)',
        }}
      />
      <path
        d='M211.33 87.75l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-H)',
        }}
      />
      <path
        d='M211.33 86.3l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-I)',
        }}
      />
      <path
        d='M211.33 84.92l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-J)',
        }}
      />
      <path
        d='M211.33 83.47l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-K)',
        }}
      />
      <path
        d='M211.33 82.09l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-L)',
        }}
      />
      <path
        d='M211.33 80.64l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-M)',
        }}
      />
      <path
        d='M211.33 79.26l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-N)',
        }}
      />
      <path
        d='M211.33 77.81l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-O)',
        }}
      />
      <path
        d='M211.33 76.39l-15.92-.93'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-P)',
        }}
      />
      <path
        d='M211.33 74.94l-15.92-.93'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-Q)',
        }}
      />
      <path
        d='M211.33 73.57l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-R)',
        }}
      />
      <path
        d='M211.33 72.11l-15.92-.93'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-S)',
        }}
      />
      <path
        d='M211.33 70.74l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-T)',
        }}
      />
      <path
        d='M211.33 69.28l-15.92-.93'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-U)',
        }}
      />
      <path
        d='M211.33 67.91l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-V)',
        }}
      />
      <path
        d='M211.33 66.46l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-W)',
        }}
      />
      <path
        d='M211.33 65.08l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-X)',
        }}
      />
      <path
        d='M211.33 63.63l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-Y)',
        }}
      />
      <path
        d='M211.33 62.25l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-Z)',
        }}
      />
      <path
        d='M211.33 60.8l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-aa)',
        }}
      />
      <path
        d='M194.3 89.61V51.42l18.11 1.05v38.19'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          stroke: 'url(#s-22d4241c82-ab)',
        }}
      />
      <circle
        cx='197.22'
        cy='67.78'
        r='1.36'
        style={{
          fill: 'url(#s-22d4241c82-b)',
        }}
      />
      <path
        d='M197.22 67.78l3.45.17'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.5px',
          stroke: 'url(#s-22d4241c82-c)',
        }}
      />
    </g>
    <image
      id='arena'
      width='1788'
      height='646'
      transform='matrix(.24 0 0 .24 30.87 63.12)'
      xlinkHref={_14x154}
    />
    <g
      id='wicketArena'
    >
      <path
        d='M221.9 90.21l-19.63-1.17V64.37l19.63 1.08v24.76z'
        style={{
          fill: '#fff',
        }}
      />
      <path
        d='M220.21 71.42l1.08.04v-1.38l-1.08-.07v1.41zM220.21 85.95l1.08.04v-1.38l-1.08-.07v1.41zM202.97 70.8l.91.04v-1.38l-.91-.08v1.42zM202.97 85.33l.91.04v-1.39l-.91-.07v1.42z'
        style={{
          fill: '#9e9e9e',
        }}
      />
      <path
        d='M202.27 65.18v25.24'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '2px',
          stroke: 'url(#s-22d4241c82-ac)',
        }}
      />
      <path
        d='M213.04 66.19v23.35'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-ad)',
        }}
      />
      <path
        d='M212.06 66.12v23.34'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-ae)',
        }}
      />
      <path
        d='M211.15 66.06V89.4'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-af)',
        }}
      />
      <path
        d='M210.24 66.01v23.34'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-ag)',
        }}
      />
      <path
        d='M209.26 65.94v23.34'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-ah)',
        }}
      />
      <path
        d='M208.34 65.88v23.35'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-ai)',
        }}
      />
      <path
        d='M207.46 65.79v23.35'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-aj)',
        }}
      />
      <path
        d='M206.48 65.72v23.24'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-ak)',
        }}
      />
      <path
        d='M219.56 66.59v23.34'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-al)',
        }}
      />
      <path
        d='M218.65 66.53v23.35'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-am)',
        }}
      />
      <path
        d='M217.74 66.48v23.35'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-an)',
        }}
      />
      <path
        d='M216.76 66.41v23.35'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-ao)',
        }}
      />
      <path
        d='M215.84 66.35V89.7'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-ap)',
        }}
      />
      <path
        d='M214.96 66.26v23.35'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-aq)',
        }}
      />
      <path
        d='M213.98 66.19v23.24'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-ar)',
        }}
      />
      <path
        d='M205.56 65.68v23.24'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-as)',
        }}
      />
      <path
        d='M204.65 65.68v23.11'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-at)',
        }}
      />
      <path
        d='M220.09 68.35l-16.29-.76'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-au)',
        }}
      />
      <path
        d='M220.09 67.53l-16.21-.87'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-av)',
        }}
      />
      <path
        d='M220.06 66.89l-16.18-.95'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-aw)',
        }}
      />
      <path
        d='M220.09 69.09l-16.29-.76'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-ax)',
        }}
      />
      <path
        d='M220.09 69.79l-16.29-.76'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-ay)',
        }}
      />
      <path
        d='M220.09 70.48l-16.29-.77'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-az)',
        }}
      />
      <path
        d='M220.09 71.2l-16.29-.76'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-aA)',
        }}
      />
      <path
        d='M220.09 71.94l-16.29-.76'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-aB)',
        }}
      />
      <path
        d='M220.09 72.64l-16.29-.76'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-aC)',
        }}
      />
      <path
        d='M220.09 73.32l-16.29-.76'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-aD)',
        }}
      />
      <path
        d='M220.09 74.07l-16.29-.76'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-aE)',
        }}
      />
      <path
        d='M220.09 74.82l-16.29-.77'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-aF)',
        }}
      />
      <path
        d='M220.09 75.51l-16.29-.76'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-aG)',
        }}
      />
      <path
        d='M220.09 76.2l-16.29-.76'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-aH)',
        }}
      />
      <path
        d='M220.09 76.92l-16.29-.76'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-aI)',
        }}
      />
      <path
        d='M220.09 77.66l-16.29-.76'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-aJ)',
        }}
      />
      <path
        d='M220.09 78.36l-16.29-.76'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-aK)',
        }}
      />
      <path
        d='M220.09 79.05l-16.29-.77'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-aL)',
        }}
      />
      <path
        d='M220.09 79.74l-16.29-.76'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-aM)',
        }}
      />
      <path
        d='M220.09 80.49l-16.29-.76'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-aN)',
        }}
      />
      <path
        d='M220.09 81.18l-16.29-.76'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-aO)',
        }}
      />
      <path
        d='M220.09 81.87l-16.29-.76'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-aP)',
        }}
      />
      <path
        d='M220.09 82.59l-16.29-.76'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-aQ)',
        }}
      />
      <path
        d='M220.09 83.34l-16.29-.76'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-aR)',
        }}
      />
      <path
        d='M220.09 84.03l-16.29-.76'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-aS)',
        }}
      />
      <path
        d='M220.09 84.72l-16.29-.76'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-aT)',
        }}
      />
      <path
        d='M220.09 85.46l-16.29-.76'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-aU)',
        }}
      />
      <path
        d='M220.09 86.21l-16.29-.76'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-aV)',
        }}
      />
      <path
        d='M220.09 86.9l-16.29-.76'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-aW)',
        }}
      />
      <path
        d='M220.09 87.59l-16.29-.76'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-aX)',
        }}
      />
      <path
        d='M220.09 88.31l-16.29-.76'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-aY)',
        }}
      />
      <path
        d='M220.09 89.03l-16.29-.76'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-22d4241c82-aZ)',
        }}
      />
      <path
        d='M463 336.51l15.71.93v22.85l-15.71-.92v-22.86m-.5-.53v23.86l16.71 1V337l-16.71-1z'
        style={{
          fill: 'url(#s-22d4241c82-ba)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M221.9 66.28v25.23'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '2px',
          stroke: 'url(#s-22d4241c82-bb)',
        }}
      />
      <circle
        cx='206.4'
        cy='77.37'
        r='1.12'
        style={{
          fill: 'url(#s-22d4241c82-bc)',
        }}
      />
      <path
        d='M206.4 77.37l2.86.13'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.5px',
          stroke: 'url(#s-22d4241c82-bd)',
        }}
      />
    </g>
    <g
      id='basketballAcross'
      className='basketball'
    >
      <path
        d='M549.76 333.71a.32.32 0 0 1-.27-.16l-9-16.84a.3.3 0 0 1 .54-.28l9 16.83a.3.3 0 0 1-.12.41.28.28 0 0 1-.15.04z'
        style={{
          fill: 'url(#s-22d4241c82-d)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M293.06 101.73l-2.39-.11V53.39h2.39v48.34z'
        style={{
          fill: '#a6a6a6',
        }}
      />
      <path
        d='M293.06 101.73l.94-.52V53.08l-.94.31v48.34z'
        style={{
          fill: '#6f6f73',
        }}
      />
      <path
        d='M294 53.08l-.94.31h-2.39l1.66-.37 1.67.06z'
        style={{
          fill: '#858589',
        }}
      />
      <path
        d='M292.82 68.04h-1.81l-2.88-12.78h1.81l2.88 12.78z'
        style={{
          fill: '#969696',
        }}
      />
      <path
        d='M292.82 63.88l.01 4.16-2.89-12.78h-1.81l.87-.9h1.67l2.15 9.52z'
        style={{
          fill: '#6f6f73',
        }}
      />
      <path
        d='M550.94 333.66h-.1a.3.3 0 0 1-.19-.38l5.26-16.36a.31.31 0 1 1 .58.19l-5.26 16.36a.31.31 0 0 1-.29.19z'
        style={{
          fill: 'url(#s-22d4241c82-be)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M277.11 40.79h.31v16.29h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-e)',
        }}
      />
      <path
        d='M277.79 40.82h.31v16.29h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-bf)',
        }}
      />
      <path
        d='M278.44 40.85h.31v16.29h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-bg)',
        }}
      />
      <path
        d='M279.12 40.9h.31v16.29h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-bh)',
        }}
      />
      <path
        d='M279.77 40.96h.31v16.29h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-bi)',
        }}
      />
      <path
        d='M280.45 40.99h.31v16.29h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-bj)',
        }}
      />
      <path
        d='M281.1 41.02h.31v16.29h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-bk)',
        }}
      />
      <path
        d='M281.78 41.07h.31v16.29h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-bl)',
        }}
      />
      <path
        d='M282.42 41.1h.31v16.29h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-bm)',
        }}
      />
      <path
        d='M283.09 41.13h.31v16.29h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-bn)',
        }}
      />
      <path
        d='M283.74 41.16h.31v16.29h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-bo)',
        }}
      />
      <path
        d='M284.42 41.21h.31V57.5h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-bp)',
        }}
      />
      <path
        d='M285.08 41.27h.31v16.29h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-bq)',
        }}
      />
      <path
        d='M285.75 41.3h.31v16.29h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-br)',
        }}
      />
      <path
        d='M286.4 41.33h.31v16.29h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-bs)',
        }}
      />
      <path
        d='M287.08 41.38h.31v16.29h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-bt)',
        }}
      />
      <path
        d='M287.78 41.42h.31v16.29h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-bu)',
        }}
      />
      <path
        d='M288.45 41.45h.31v16.29h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-bv)',
        }}
      />
      <path
        d='M289.1 41.48h.31v16.29h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-bw)',
        }}
      />
      <path
        d='M289.78 41.53h.31v16.29h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-bx)',
        }}
      />
      <path
        d='M290.44 41.6h.31v16.29h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-by)',
        }}
      />
      <path
        d='M291.11 41.62h.31v16.29h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-bz)',
        }}
      />
      <path
        d='M291.76 41.66h.31v16.29h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-bA)',
        }}
      />
      <path
        d='M292.44 41.7h.31v16.29h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-bB)',
        }}
      />
      <path
        d='M293.08 41.73h.31v16.29h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-bC)',
        }}
      />
      <path
        d='M293.76 41.76h.31v16.29h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-bD)',
        }}
      />
      <path
        d='M294.41 41.79h.31v16.29h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-bE)',
        }}
      />
      <path
        d='M295.08 41.84h.31v16.29h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-bF)',
        }}
      />
      <path
        d='M295.74 41.9h.31v16.29h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-bG)',
        }}
      />
      <path
        d='M296.42 41.93h.31v16.29h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-bH)',
        }}
      />
      <path
        d='M297.07 41.96h.31v16.29h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-bI)',
        }}
      />
      <path
        d='M297.74 42.01h.31V58.3h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-bJ)',
        }}
      />
      <path
        d='M298.37 42.01h.31V58.3h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-bK)',
        }}
      />
      <path
        d='M299.02 42.04h.31v16.29h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-bL)',
        }}
      />
      <path
        d='M299.7 42.09h.31v16.29h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-bM)',
        }}
      />
      <path
        d='M300.36 42.15h.31v16.29h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-bN)',
        }}
      />
      <path
        d='M301.03 42.18h.31v16.29h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-bO)',
        }}
      />
      <path
        d='M301.68 42.21h.31V58.5h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-bP)',
        }}
      />
      <path
        d='M302.36 42.26h.31v16.29h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-bQ)',
        }}
      />
      <path
        d='M548.59 300.14h.31v27.2h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-bR)',
        }}
        transform='rotate(-86.78 276.15 315.276)'
      />
      <path
        d='M548.59 299.46h.31v27.2h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-bS)',
        }}
        transform='rotate(-86.78 276.15 314.586)'
      />
      <path
        d='M548.59 301.52h.31v27.2h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-bT)',
        }}
        transform='rotate(-86.78 276.152 316.65)'
      />
      <path
        d='M548.59 300.83h.31v27.2h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-bU)',
        }}
        transform='rotate(-86.78 276.153 315.96)'
      />
      <path
        d='M548.59 302.97h.31v27.2h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-bV)',
        }}
        transform='rotate(-86.78 276.152 318.102)'
      />
      <path
        d='M548.59 302.28h.31v27.2h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-bW)',
        }}
        transform='rotate(-86.78 276.153 317.412)'
      />
      <path
        d='M548.59 304.34h.31v27.2h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-bX)',
        }}
        transform='rotate(-86.78 276.149 319.472)'
      />
      <path
        d='M548.59 303.65h.31v27.2h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-bY)',
        }}
        transform='rotate(-86.78 276.155 318.787)'
      />
      <path
        d='M548.59 305.79h.31v27.2h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-bZ)',
        }}
        transform='rotate(-86.78 276.148 320.924)'
      />
      <path
        d='M548.59 305.1h.31v27.2h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-ca)',
        }}
        transform='rotate(-86.78 276.15 320.234)'
      />
      <path
        d='M548.59 307.16h.31v27.2h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-cb)',
        }}
        transform='rotate(-86.78 276.151 322.298)'
      />
      <path
        d='M548.59 306.48h.31v27.2h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-cc)',
        }}
        transform='rotate(-86.78 276.152 321.609)'
      />
      <path
        d='M548.59 308.62h.31v27.2h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-cd)',
        }}
        transform='rotate(-86.78 276.15 323.75)'
      />
      <path
        d='M548.59 307.93h.31v27.2h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-ce)',
        }}
        transform='rotate(-86.78 276.152 323.06)'
      />
      <path
        d='M548.59 309.3h.31v27.2h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-cf)',
        }}
        transform='rotate(-86.78 276.144 324.435)'
      />
      <path
        d='M548.59 310.75h.31v27.2h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-cg)',
        }}
        transform='rotate(-86.78 276.154 325.887)'
      />
      <path
        d='M548.59 310.07h.31v27.2h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-ch)',
        }}
        transform='rotate(-86.78 276.155 325.197)'
      />
      <path
        d='M548.59 312.13h.31v27.2h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-ci)',
        }}
        transform='rotate(-86.78 276.146 327.262)'
      />
      <path
        d='M548.59 311.44h.31v27.2h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-cj)',
        }}
        transform='rotate(-86.78 276.148 326.572)'
      />
      <path
        d='M548.59 313.58h.31v27.2h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-ck)',
        }}
        transform='rotate(-86.78 276.151 328.709)'
      />
      <path
        d='M548.59 312.89h.31v27.2h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-cl)',
        }}
        transform='rotate(-86.78 276.157 328.024)'
      />
      <path
        d='M548.59 314.27h.31v27.2h-.31z'
        style={{
          fill: 'url(#s-22d4241c82-cm)',
        }}
        transform='rotate(-86.78 276.15 329.399)'
      />
      <path
        d='M290.53 57.41l-2.4-.09v-2.06l2.4.13v2.02z'
        style={{
          fill: 'gray',
        }}
      />
      <path
        d='M562.63 329.54L534.86 328v-16.87l27.77 1.56zm-27.16-2.14l26.53 1.5v-15.63l-26.55-1.5z'
        style={{
          fill: 'url(#s-22d4241c82-f)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M553.44 326.64l-10.23-.56v-8.46l10.23.56zm-9.62-1.14l9 .5v-7.24l-9-.5z'
        style={{
          fill: 'url(#s-22d4241c82-cn)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M548.43 326.9a3 3 0 0 0-1.14-.25 4.45 4.45 0 0 0-1.35.08l1-.75 2.45.13z'
        style={{
          fill: '#b0b0b5',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M547.66 327.17l-6.08 1.91a.12.12 0 0 1-.16-.08.12.12 0 0 1 .08-.15l6.09-1.92a.12.12 0 0 1 .15.08.13.13 0 0 1-.08.16z'
        style={{
          fill: 'url(#s-22d4241c82-g)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M550.36 329.42a.22.22 0 0 1 0 .14.1.1 0 0 1-.17 0l-2.11-2.39a.22.22 0 0 1 0-.23c0-.07.11-.07.17 0l2.11 2.38a.19.19 0 0 1 0 .1z'
        style={{
          fill: 'url(#s-22d4241c82-co)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M546.34 330.5c-2.76.06-5-.76-5.1-1.82s2.14-2 4.9-2 5 .76 5.09 1.83-2.14 1.93-4.89 1.99zm-.19-3.67c-2.6.06-4.66.88-4.61 1.84s2.19 1.7 4.79 1.64 4.66-.88 4.61-1.84-2.2-1.69-4.79-1.64z'
        style={{
          fill: 'url(#s-22d4241c82-cp)',
        }}
        transform='translate(-258.81 -270.72)'
      />
    </g>
    <g
      className='football'
    >
      <path
        d='M425.42 377.61c33.6-2.33 96.63 13.47 68.17 33.79-48.06 34.3-144 31.17-171.24 27.73M674.11 391.05c-86-5.53-125.93 10-125.54 26.19.51 20.93 48.68 46 151.88 52.83'
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeMiterlimit: '10',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M114.59 144.77l-18.97-1.2v-1.74l34.7-20.7 16.85 2.3v1.73l-16.23-1.02-27.91 16.92 11.57 1.97-.01 1.74z'
        style={{
          fill: 'url(#s-22d4241c82-h)',
        }}
      />
      <path
        d='M114.57 143.03l-18.95-1.2 34.7-20.7 17.63 1.11-.91 1.19-16.41-1.04-30.95 18.46 16.55 1.05-1.66 1.13z'
        style={{
          fill: 'url(#s-22d4241c82-i)',
        }}
      />
      <path
        d='M392 392.56l-.49-.09 5.68-28.89a2.43 2.43 0 0 1 2.51-1.95l6.23.36v.5l-6.24-.37a1.94 1.94 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-22d4241c82-cq)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M394.19 392.7l-.48-.09 5.12-26.08a2.43 2.43 0 0 1 2.52-1.95l4.53.27v.49l-4.54-.27a1.93 1.93 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-22d4241c82-cr)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M396.37 392.84l-.49-.1 4.6-23.37a2.42 2.42 0 0 1 2.51-1.95l2.89.17v.49l-2.9-.17a1.94 1.94 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-22d4241c82-cs)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M398.52 393l-.48-.1 4-20.15a2.43 2.43 0 0 1 2.51-2l1.39.08v.5l-1.4-.08a1.93 1.93 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-22d4241c82-ct)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M400.69 393.11l-.49-.09 3.47-17.68a2.43 2.43 0 0 1 2.2-1.94v.49a1.92 1.92 0 0 0-1.75 1.55z'
        style={{
          fill: 'url(#s-22d4241c82-cu)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M402.74 393.24l-.49-.09 3.17-16.15a2.25 2.25 0 0 1 .23-.66l.44.23a2.1 2.1 0 0 0-.19.53z'
        style={{
          fill: 'url(#s-22d4241c82-cv)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M389.19 392.46l-.48-.09 6.18-31.44a2.43 2.43 0 0 1 2.51-1.93l8.5.5v.49l-8.51-.49a1.93 1.93 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-22d4241c82-cw)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M386.7 394l-.49-.1 6.18-31.43a2.43 2.43 0 0 1 2.51-1.95l8.51.5v.49l-8.51-.49a1.94 1.94 0 0 0-2 1.54z'
        style={{
          fill: 'url(#s-22d4241c82-cx)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M384.2 395.37l-.49-.1 6.18-31.44a2.42 2.42 0 0 1 2.51-1.94l8.51.49v.5l-8.51-.5a1.93 1.93 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-22d4241c82-cy)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M381.7 397l-.49-.1 6.18-31.43a2.42 2.42 0 0 1 2.52-1.95l8.5.5v.49l-8.5-.5a1.93 1.93 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-22d4241c82-cz)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M379 398.57l-.49-.1 6.16-31.47a2.43 2.43 0 0 1 2.52-2l8.5.49v.5l-8.5-.5a1.92 1.92 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-22d4241c82-cA)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M376.48 400.08L376 400l6.18-31.43a2.41 2.41 0 0 1 2.51-1.95l8.5.49v.5l-8.51-.5a1.93 1.93 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-22d4241c82-cB)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M374 401.47l-.48-.09 6.18-31.44a2.43 2.43 0 0 1 2.51-1.95l8.5.5v.49l-8.5-.49a1.93 1.93 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-22d4241c82-cC)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M371.49 403.06L371 403l6.18-31.44a2.41 2.41 0 0 1 2.51-1.94l8.51.49v.5l-8.51-.5a1.94 1.94 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-22d4241c82-cD)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M369.06 404.63l-.48-.09 6.17-31.44a2.43 2.43 0 0 1 2.52-1.94l8.5.49v.5l-8.5-.5a1.93 1.93 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-22d4241c82-cE)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M366.57 406.14l-.49-.09 6.18-31.44a2.43 2.43 0 0 1 2.51-1.95l8.51.5v.5l-8.51-.5a1.93 1.93 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-22d4241c82-cF)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M364.07 407.54l-.49-.1 6.18-31.44a2.43 2.43 0 0 1 2.51-1.95l8.51.5v.49l-8.51-.5a1.94 1.94 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-22d4241c82-cG)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M361.57 409.13l-.49-.09 6.18-31.44a2.43 2.43 0 0 1 2.52-2l8.5.5v.49l-8.5-.49a1.92 1.92 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-22d4241c82-cH)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M359 410.65l-.49-.1 6.18-31.43a2.43 2.43 0 0 1 2.51-1.95l8.51.5v.49l-8.51-.5a1.93 1.93 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-22d4241c82-cI)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M356.71 412.11l-.49-.1 6.18-31.43a2.43 2.43 0 0 1 2.51-1.95l8.51.5v.49l-8.51-.5a2 2 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-22d4241c82-cJ)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M359.5 412.29l-.49-.1 5.68-28.89a2.41 2.41 0 0 1 2.51-1.94l6.24.36v.49l-6.24-.36a1.94 1.94 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-22d4241c82-cK)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M361.73 412.43l-.49-.1 5.13-26.08a2.43 2.43 0 0 1 2.51-1.95l4.54.27v.49l-4.54-.26a1.93 1.93 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-22d4241c82-cL)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M363.9 412.56l-.49-.09 4.6-23.38a2.43 2.43 0 0 1 2.51-1.95l2.9.17v.5l-2.89-.17a1.94 1.94 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-22d4241c82-cM)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M366.06 412.7l-.49-.09 4-20.16a2.41 2.41 0 0 1 2.51-1.94l1.4.08v.49L372 391a1.92 1.92 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-22d4241c82-cN)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M368.22 412.84l-.49-.1 3.48-17.67a2.42 2.42 0 0 1 2.19-1.95v.5a1.92 1.92 0 0 0-1.75 1.54z'
        style={{
          fill: 'url(#s-22d4241c82-cO)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M370.27 413l-.49-.1 3.17-16.1a2.25 2.25 0 0 1 .23-.66l.44.23a1.61 1.61 0 0 0-.18.52z'
        style={{
          fill: 'url(#s-22d4241c82-cP)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M114.7 144.53l-1.6-.65.12-36.54 33.52-20.24 1.92.58-1.49 37.48-1.49-.09v-35.6l-30.98 18.71v36.35z'
        style={{
          fill: 'url(#s-22d4241c82-cQ)',
        }}
      />
      <path
        d='M116.19 143.15l-1.6 1.62.11-36.59 33.96-20.5v36l-1.49 1.48V90.31l-30.98 18.71v34.13z'
        style={{
          fill: 'url(#s-22d4241c82-j)',
        }}
      />
      <path
        d='M425.08 172.36l17.15.99v-1.66l-9.81-28.9-16.17.36v1.66l14.14.8 8.01 24.87-14.41.17 1.09 1.71z'
        style={{
          fill: 'url(#s-22d4241c82-cS)',
        }}
      />
      <path
        d='M424.02 170.55l18.21 1.04-9.81-28.8-16.92-.78.87 1.14 15.04.85 8.68 26.57-16.08-1.11.01 1.09z'
        style={{
          fill: 'url(#s-22d4241c82-cT)',
        }}
      />
      <path
        d='M688 414.08l-3.41-28.16a1.86 1.86 0 0 0-1.77-1.69l-7.73-.31v-.48l7.73.31a2.34 2.34 0 0 1 2.22 2.12l3.39 28.13z'
        style={{
          fill: 'url(#s-22d4241c82-cU)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M685.78 414l-3.16-25.42a1.89 1.89 0 0 0-1.78-1.7l-5.61-.22v-.47l5.61.22a2.35 2.35 0 0 1 2.23 2.12l3.17 25.42z'
        style={{
          fill: 'url(#s-22d4241c82-cV)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M683.67 413.89l-2.94-22.79a1.87 1.87 0 0 0-1.78-1.7l-3.72-.14v-.48l3.72.15a2.34 2.34 0 0 1 2.23 2.12l2.94 22.78z'
        style={{
          fill: 'url(#s-22d4241c82-cW)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M681.57 413.79l-2.66-19.64a1.89 1.89 0 0 0-1.78-1.7l-1.9-.07v-.47l1.9.06a2.36 2.36 0 0 1 2.23 2.13l2.64 19.63z'
        style={{
          fill: 'url(#s-22d4241c82-cX)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M679.46 413.7L677 396.47a2.18 2.18 0 0 0-1.81-1.67l.08-.47a2.63 2.63 0 0 1 2.2 2.09l2.45 17.21z'
        style={{
          fill: 'url(#s-22d4241c82-cY)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M677.46 413.61l-2.32-15.7a1.79 1.79 0 0 0-.12-.53l.44-.18a2.45 2.45 0 0 1 .16.66l2.31 15.68z'
        style={{
          fill: 'url(#s-22d4241c82-cZ)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M690.48 414.08l-3.65-30.2a2 2 0 0 0-1.93-1.83l-10-.33v-.48l10 .33a2.51 2.51 0 0 1 2.38 2.26L691 414z'
        style={{
          fill: 'url(#s-22d4241c82-da)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M691.26 416.35l-3.65-30.21a2 2 0 0 0-1.92-1.83l-10-.33v-.48l10 .33a2.5 2.5 0 0 1 2.37 2.27l3.65 30.19z'
        style={{
          fill: 'url(#s-22d4241c82-db)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M692 418.49l-3.66-30.21a2 2 0 0 0-1.92-1.83l-10-.33v-.47l10 .32a2.52 2.52 0 0 1 2.38 2.27l3.65 30.19z'
        style={{
          fill: 'url(#s-22d4241c82-dc)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M692.87 421.17L689.22 391a2 2 0 0 0-1.92-1.83l-10-.33v-.47l10 .32a2.5 2.5 0 0 1 2.37 2.27l3.65 30.19z'
        style={{
          fill: 'url(#s-22d4241c82-dd)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M693.62 423.07l-3.62-30.2a2 2 0 0 0-1.92-1.83l-10-.33v-.48l10 .33a2.51 2.51 0 0 1 2.38 2.26L694.1 423z'
        style={{
          fill: 'url(#s-22d4241c82-de)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M694.39 425.3l-3.65-30.2a2 2 0 0 0-1.92-1.83l-10-.33v-.48l10 .33a2.5 2.5 0 0 1 2.37 2.26l3.65 30.2z'
        style={{
          fill: 'url(#s-22d4241c82-df)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M695.17 427.54l-3.65-30.2a2 2 0 0 0-1.92-1.83l-10-.33v-.48l10 .33a2.51 2.51 0 0 1 2.37 2.26l3.65 30.19z'
        style={{
          fill: 'url(#s-22d4241c82-dg)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M696 430.24L692.36 400a2 2 0 0 0-1.92-1.84l-10-.33v-.47l10 .33a2.49 2.49 0 0 1 2.37 2.26l3.65 30.19z'
        style={{
          fill: 'url(#s-22d4241c82-dh)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M696.82 432.6l-3.65-30.21a2 2 0 0 0-1.92-1.83l-10-.33v-.47l10 .32a2.52 2.52 0 0 1 2.37 2.27l3.65 30.19z'
        style={{
          fill: 'url(#s-22d4241c82-di)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M697.61 435L694 404.79a2 2 0 0 0-2-1.79l-10-.33v-.47l10 .33a2.5 2.5 0 0 1 2.38 2.26l3.65 30.19z'
        style={{
          fill: 'url(#s-22d4241c82-dj)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M698.4 437.38l-3.65-30.2a2 2 0 0 0-1.92-1.84l-10-.33v-.47l10 .33a2.49 2.49 0 0 1 2.37 2.26l3.66 30.19z'
        style={{
          fill: 'url(#s-22d4241c82-dk)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M698.88 438.85l-3.28-28.77a2 2 0 0 0-1.92-1.84l-10-.33v-.47l10 .33a2.49 2.49 0 0 1 2.37 2.26l3.28 28.77z'
        style={{
          fill: 'url(#s-22d4241c82-dl)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M699.35 440.52l-3-28.23a2 2 0 0 0-1.92-1.83l-10-.33v-.48l10 .33a2.5 2.5 0 0 1 2.37 2.26l3 28.22z'
        style={{
          fill: 'url(#s-22d4241c82-dm)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M699.82 441.6l-2.61-26.68a2 2 0 0 0-1.92-1.84l-10.63-.32v-.48l10.64.33a2.49 2.49 0 0 1 2.37 2.26l2.61 26.67z'
        style={{
          fill: 'url(#s-22d4241c82-dn)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M697.84 441.7l-3.68-24.87a1.87 1.87 0 0 0-1.78-1.7l-7.73-.31v-.47l7.73.3a2.35 2.35 0 0 1 2.23 2.13l3.68 24.86z'
        style={{
          fill: 'url(#s-22d4241c82-do)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M695.64 441.73l-3.42-22.27a1.86 1.86 0 0 0-1.77-1.69l-5.62-.23v-.47l5.62.22a2.35 2.35 0 0 1 2.23 2.12l3.41 22.26z'
        style={{
          fill: 'url(#s-22d4241c82-dp)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M693.1 441.51L690.34 422a1.9 1.9 0 0 0-1.78-1.7l-3.73-.14v-.48l3.73.15a2.35 2.35 0 0 1 2.23 2.12l2.77 19.5z'
        style={{
          fill: 'url(#s-22d4241c82-dq)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M690.77 441.48l-2.26-16.43a1.87 1.87 0 0 0-1.78-1.7l-1.89-.07v-.47l1.9.07A2.34 2.34 0 0 1 689 425l2.26 16.41z'
        style={{
          fill: 'url(#s-22d4241c82-dr)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M688.66 441.38l-2-14a2.15 2.15 0 0 0-1.81-1.67l.09-.47a2.65 2.65 0 0 1 2.2 2.09l2 13.82z'
        style={{
          fill: 'url(#s-22d4241c82-ds)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M686.6 441l-1.85-12.15a1.79 1.79 0 0 0-.13-.53l.44-.18a2.13 2.13 0 0 1 .16.66l1.85 12.13z'
        style={{
          fill: 'url(#s-22d4241c82-dt)',
        }}
        transform='translate(-258.81 -270.72)'
      />
      <path
        d='M424.97 172.13l1.53-.63-.36-31.61-9.48-29.69h-2.09l1.68 34.62 1.43-.1-.19-25.75 7.23 21.74.25 31.42z'
        style={{
          fill: 'url(#s-22d4241c82-du)',
        }}
      />
      <path
        d='M423.53 170.82l1.55 1.54-.36-31.65-10.15-30.51.24 33.2 1.44 1.41-.14-24.84 7.18 21.55.24 29.3z'
        style={{
          fill: 'url(#s-22d4241c82-dv)',
        }}
      />
    </g>
    <g
      className='badminton'
    >
      <path
        d='M286.07 114.54V74.25'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '2px',
          stroke: 'url(#s-22d4241c82-k)',
        }}
      />
      <path
        d='M281.43 94.93l-38.16 51.65'
        style={{
          fill: 'none',
          stroke: '#333',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
        }}
      />
      <path
        d='M281.43 84.4l-37.53 48.58M281.43 86.15L243.9 134.7M281.43 87.79l-37.53 48.69M281.43 89.42l-37.53 48.82M281.49 90.93l-37.59 48.93M281.43 92.35l-37.53 49.23M281.35 93.71l-37.45 49.65'
        style={{
          fill: 'none',
          stroke: '#333',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.150000005960464px',
        }}
      />
      <path
        d='M245.9 127.81v15.38M245.23 128.2v15.38M244.4 129.22v15.38M246.55 126.97v15.19M247.25 126.06v15.04M247.95 124.87v15.38M248.6 124.03v15.2M249.29 123.13v15.04M250.04 122.33v15.39M250.69 121.49v15.2M251.39 120.59v15.04M252.09 119.4v15.38M252.74 118.56v15.2M253.44 117.66v15.03M254.15 116.98v15.38M254.8 116.14v15.2M255.5 115.24v15.04M256.2 114.04v15.39M256.85 113.21v15.19M257.54 112.3v15.04M258.19 111.6v15.39M258.83 110.77v15.19M259.53 109.86v15.04M260.23 108.67v15.38M260.88 107.83v15.2M261.58 107.5v13.9M262.33 106.7v14.25M262.97 105.86v14.06M263.67 104.96v13.9M264.37 103.76v14.25M265.02 102.93v14.06M265.72 102.02v13.91M266.44 101.34v14.25M267.08 100.51v14.06M267.78 99.6v13.91M268.48 98.41v14.25M269.13 97.57v14.06M269.83 96.67v13.9M270.51 95.72v13.9M271.26 94.92v14.25M271.9 94.08v14.06M272.6 93.18v13.9M273.3 91.99v14.24M273.95 91.15v14.06M274.65 90.24v13.91M275.37 89.57v14.24M276.01 88.73v14.06M276.71 87.83v13.9M277.41 86.63v14.25M278.06 85.79v14.06M278.76 84.89v13.9M279.33 83.99v14.25M279.98 83.15v14.06M280.67 82.25v13.9'
        style={{
          fill: 'none',
          stroke: '#333',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.150999993085861px',
        }}
      />
      <path
        d='M243.27 130.86l-7.87 9.28M243.4 145.84l-9.43 14.45M243.27 140.67l-7.87 10.81M281.43 81.81l4.76-6.3M281.49 90.93l4.63-5.67M281.49 94.74l4.58-4.98'
        style={{
          fill: 'none',
          stroke: '#333',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.5px',
        }}
      />
      <path
        d='M281.43 94.92V81.81l-38.16 49.05v15.27'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          stroke: 'url(#s-22d4241c82-dw)',
        }}
      />
      <path
        d='M235.4 187.46v-50.42'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '2px',
          stroke: 'url(#s-22d4241c82-dx)',
        }}
      />
    </g>
    <g
      id='unihockey'
    >
      <g
        id='unihockeyLeft'
      >
        <path
          d='M154.85 151.4l-44.43-2.58L152 122.55l40.87 2.72-38.02 26.13z'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
        />
        <path
          d='M393.08 412.52l-11.91-.75v-1.09L402 398.23a3.16 3.16 0 0 1 2-.41l9.5 1.3v1.09l-9.22-.58a3.08 3.08 0 0 0-1.8.44l-16.69 10.12 7.26 1.24z'
          style={{
            fill: 'url(#s-22d4241c82-l)',
          }}
          transform='translate(-258.81 -270.72)'
        />
        <path
          d='M392.94 411.42l-11.77-.74 21-12.51a3.11 3.11 0 0 1 1.79-.43l10.11.64-.45.58a.41.41 0 0 1-.33.15l-9.14-.58a3.11 3.11 0 0 0-1.79.43l-18.61 11.1 10.4.66-.94.64a.34.34 0 0 1-.27.06z'
          style={{
            fill: 'url(#s-22d4241c82-dy)',
          }}
          transform='translate(-258.81 -270.72)'
        />
        <path
          d='M412.86 379a26.14 26.14 0 0 1-5.79-.58v-.11a26.79 26.79 0 0 0 6.25.58v.11zM412.81 378.44a23.72 23.72 0 0 1-5.49-.56v-.11a24.73 24.73 0 0 0 6 .56v.1zM412.91 380.18a28.37 28.37 0 0 1-6.06-.6v-.11a28.19 28.19 0 0 0 6.47.6v.11zM412.89 379.6a27.29 27.29 0 0 1-5.89-.6v-.11a27.79 27.79 0 0 0 6.36.59v.11zM412.83 381.23a29.2 29.2 0 0 1-6.13-.58v-.11a30 30 0 0 0 6.62.58v.11zM412.92 380.65a29.18 29.18 0 0 1-6.16-.61v-.11a29.5 29.5 0 0 0 6.56.61v.11zM412.88 382.39a32.34 32.34 0 0 1-6.47-.6v-.11a31.9 31.9 0 0 0 6.9.6v.11zM412.84 381.81a30.34 30.34 0 0 1-6.32-.58v-.11a31.18 31.18 0 0 0 6.8.58v.11zM412.93 383.56a34 34 0 0 1-6.74-.63v-.11a34.85 34.85 0 0 0 7.13.63v.11zM413 383a33.12 33.12 0 0 1-6.67-.68v-.11a33.43 33.43 0 0 0 7 .67v.12zM412.77 384.72a35.9 35.9 0 0 1-6.8-.58v-.11a36.83 36.83 0 0 0 7.35.58v.11zM412.94 384.14a35.08 35.08 0 0 1-6.86-.64v-.1a36.63 36.63 0 0 0 7.24.63v.11zM412.83 385.77a38.53 38.53 0 0 1-7.08-.6v-.11a38.35 38.35 0 0 0 7.57.6v.11zM412.8 385.19a37.17 37.17 0 0 1-6.94-.59v-.11a38 38 0 0 0 7.46.59v.11zM413 386.93a41.4 41.4 0 0 1-7.48-.73v-.11a40 40 0 0 0 7.77.73v.11zM412.85 386.35a39 39 0 0 1-7.21-.61v-.1a40.3 40.3 0 0 0 7.68.6v.11zM413 387.52a42.41 42.41 0 0 1-7.56-.71v-.11a40.72 40.72 0 0 0 7.89.7v.11zM412.91 388.68a44.29 44.29 0 0 1-7.72-.65v-.1a45.06 45.06 0 0 0 8.13.64v.11zM413 388.1a43.3 43.3 0 0 1-7.68-.71v-.11a43.42 43.42 0 0 0 8 .71v.1zM412.75 389.84a46.82 46.82 0 0 1-7.8-.59v-.11a47.73 47.73 0 0 0 8.37.59v.11zM412.71 389.26a44.83 44.83 0 0 1-7.62-.58v-.11a45.17 45.17 0 0 0 8.23.58v.11zM412.79 391a49.89 49.89 0 0 1-8.07-.6v-.11a49.41 49.41 0 0 0 8.6.6v.11zM412.78 390.42a47.19 47.19 0 0 1-7.94-.6v-.1a49.14 49.14 0 0 0 8.49.59v.11zM412.81 392.06a51.15 51.15 0 0 1-8.29-.63v-.1a51.68 51.68 0 0 0 8.8.61v.11zM412.71 391.47a49.27 49.27 0 0 1-8.08-.58v-.11a49.85 49.85 0 0 0 8.7.58v.11zM412.71 393.22a54.21 54.21 0 0 1-8.39-.58v-.11a54.44 54.44 0 0 0 9 .58v.11zM413 392.64a52.81 52.81 0 0 1-8.53-.72v-.1a53 53 0 0 0 8.9.71v.1zM412.66 394.38a55.6 55.6 0 0 1-8.6-.59v-.11a56.17 56.17 0 0 0 9.27.59v.11zM412.64 393.8a55.08 55.08 0 0 1-8.45-.58v-.11a56.83 56.83 0 0 0 9.14.58v.11zM412.71 395.54a59 59 0 0 1-8.88-.6v-.11a60.06 60.06 0 0 0 9.49.6v.11zM412.68 395a58.69 58.69 0 0 1-8.74-.59v-.11a59.88 59.88 0 0 0 9.38.59v.11zM412.75 396.6a63.37 63.37 0 0 1-9.12-.62v-.11a62.85 62.85 0 0 0 9.7.61v.11zM412.73 396a60.31 60.31 0 0 1-9-.61v-.1a62.39 62.39 0 0 0 9.58.6v.11zM412.65 397.76a66.15 66.15 0 0 1-9.26-.58v-.11a66.36 66.36 0 0 0 9.93.58v.11zM412.64 397.18a63.34 63.34 0 0 1-9.13-.58v-.11a66.67 66.67 0 0 0 9.82.58v.1z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-258.81 -270.72)'
        />
        <path
          d='M145.31 127.41l-.11-.02 3.93-20.77.11.02-3.93 20.77zM146.2 127.41l-.11-.02 3.75-20.84.11.02-3.75 20.84zM153.21 127.96h-.11l.16-21.25h.11l-.16 21.25z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M400.78 387.92h21.2v.11h-21.2z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-89.4 144.796 383.318)'
        />
        <path
          d='M151.71 127.8h-.11l.44-21.1h.11l-.44 21.1zM149.06 127.65l-.1-.01 2.28-21.08.1.01-2.28 21.08z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M399.73 387.84h21v.11h-21z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-88.3 139.971 385.782)'
        />
        <path
          d='M397.81 387.7h21.11v.11h-21.11z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-82.95 125.865 398.792)'
        />
        <path
          d='M397.04 387.67h21.04v.11h-21.04z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-81.33 120.573 402.993)'
        />
        <path
          d='M150.13 127.65l-.11-.01 1.45-21.08h.11l-1.45 21.09z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M403.51 398.18l-.61-.12 3.88-19.74a1.67 1.67 0 0 1 1.74-1.35l5.34.32v.62l-5.34-.32a1.06 1.06 0 0 0-1.09.85z'
          style={{
            fill: 'url(#s-22d4241c82-dz)',
          }}
          transform='translate(-258.81 -270.72)'
        />
        <path
          d='M388.6 383.56h24.01v.08H388.6z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.96 -217.486 715.525)'
        />
        <path
          d='M385.22 383.53h24.47v.08h-24.47z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.58 -227.098 721.556)'
        />
        <path
          d='M130.78 118.92l-.04-.06 20.53-12.33.04.06-20.53 12.33zM130.09 118.81l-.04-.07 20.27-12.17.04.06-20.27 12.18zM129.11 118.93l-.04-.07 20.6-12.33.04.07-20.6 12.33z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M409.09 376.1h.08v3.27h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-86.86 136.756 379.074)'
        />
        <path
          d='M408.19 376.87h.08v2.79h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-79.7 116.672 397.953)'
        />
        <path
          d='M150.05 108.28l-2.55-.63.02-.07 2.55.63-.02.07z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M406.93 377.85h.08v2.35h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-68.96 80.474 432.09)'
        />
        <path
          d='M406.31 378.22h.08v2.35h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-68.46 78.012 434.236)'
        />
        <path
          d='M390.35 387.05h.08v4.01h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-86 116.098 391.841)'
        />
        <path
          d='M391.12 386.73h.08v3.47h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-84.68 113.172 395.12)'
        />
        <path
          d='M392.02 386.31h.08v3.21h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-81.67 106.018 402.293)'
        />
        <path
          d='M392.85 385.87h.08v3.11h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='matrix(.17 -.99 .99 .17 -314.01 438.69)'
        />
        <path
          d='M143.35 112.33l-3.04-.43.01-.07 3.04.42-.01.08zM144.25 111.79l-3.02-.43.01-.08 3.02.43-.01.08z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M393.82 385.3h.08v3.09h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-80.34 104.126 404.783)'
        />
        <path
          d='M394.63 384.89h.08v2.94h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78 98.09 410.804)'
        />
        <path
          d='M395.44 384.36h.08v3.04h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='matrix(.18 -.98 .98 .18 -312.54 436.9)'
        />
        <path
          d='M396.27 383.93h.08v2.91h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78 99.746 409.833)'
        />
        <path
          d='M139.65 114.56l-2.87-.58.01-.07 2.88.57-.02.08z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M397.89 382.9h.08v3.03h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-80.59 108.872 401.677)'
        />
        <path
          d='M405.15 378.5h.08v3.2h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='matrix(.17 -.98 .98 .17 -298.05 442.76)'
        />
        <path
          d='M148.15 109.42l-2.44-.71.02-.07 2.44.7-.02.08zM147.05 110.09l-2.76-.54.02-.08 2.76.55-.02.07z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M403.7 379.54h.08v2.77h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-79.21 110.77 401.96)'
        />
        <path
          d='M403.01 379.96h.08v2.8h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.13 106.905 405.435)'
        />
        <path
          d='M402.34 380.37h.08v2.79h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-77.77 105.13 406.864)'
        />
        <path
          d='M399.96 381.72h.08v2.94h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-79.64 108.25 403.033)'
        />
        <path
          d='M141.82 113.25l-2.83-.57.02-.08 2.83.57-.02.08z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M398.62 382.61h.08v2.76h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-75.78 95.346 414.918)'
        />
        <path
          d='M380.83 403.28h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -229.24 739.036)'
        />
        <path
          d='M380.86 402.69h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -229.218 738.455)'
        />
        <path
          d='M381.02 402.08h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -229.066 737.831)'
        />
        <path
          d='M381.2 401.54h24.27v.11H381.2z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -228.88 737.295)'
        />
        <path
          d='M381.23 400.95h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -228.857 736.714)'
        />
        <path
          d='M381.39 400.34h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -228.706 736.09)'
        />
        <path
          d='M381.45 399.84h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -228.63 735.602)'
        />
        <path
          d='M381.67 399.31h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -228.426 735.071)'
        />
        <path
          d='M381.69 398.73h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -228.385 734.495)'
        />
        <path
          d='M381.85 398.12h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -228.233 733.871)'
        />
        <path
          d='M382.03 397.57h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -228.047 733.335)'
        />
        <path
          d='M382.06 396.99h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -228.019 732.736)'
        />
        <path
          d='M382.22 396.37h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -227.872 732.13)'
        />
        <path
          d='M382.28 395.88h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -227.81 731.619)'
        />
        <path
          d='M382.38 395.31h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -227.696 731.063)'
        />
        <path
          d='M382.41 394.73h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -227.674 730.482)'
        />
        <path
          d='M382.56 394.11h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -227.522 729.858)'
        />
        <path
          d='M382.75 393.57h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -227.336 729.322)'
        />
        <path
          d='M382.77 392.99h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -227.313 728.74)'
        />
        <path
          d='M382.93 392.37h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -227.143 728.122)'
        />
        <path
          d='M382.99 391.87h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -227.086 727.629)'
        />
        <path
          d='M383.17 391.2h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -226.919 726.95)'
        />
        <path
          d='M383.32 390.58h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -226.749 726.331)'
        />
        <path
          d='M383.51 390.04h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -226.58 725.79)'
        />
        <path
          d='M383.54 389.46h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -226.54 725.214)'
        />
        <path
          d='M383.69 388.84h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -226.388 724.59)'
        />
        <path
          d='M383.75 388.34h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -226.331 724.097)'
        />
        <path
          d='M383.85 387.78h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -226.236 723.536)'
        />
        <path
          d='M383.88 387.19h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -226.195 722.96)'
        />
        <path
          d='M384.04 386.58h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -226.043 722.336)'
        />
        <path
          d='M384.22 386.04h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -225.857 721.8)'
        />
        <path
          d='M384.25 385.45h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -225.829 721.2)'
        />
        <path
          d='M384.4 384.84h24.27v.11H384.4z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -225.682 720.595)'
        />
        <path
          d='M384.47 384.34h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -225.62 720.084)'
        />
        <path
          d='M374.95 399.65h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 90.92 422.031)'
        />
        <path
          d='M376.12 398.93h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 92.092 421.311)'
        />
        <path
          d='M375.53 399.31h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 91.496 421.689)'
        />
        <path
          d='M376.64 398.65h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 92.602 421.026)'
        />
        <path
          d='M377.8 397.93h20.58v.11H377.8z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 93.774 420.306)'
        />
        <path
          d='M377.21 398.31h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 93.178 420.683)'
        />
        <path
          d='M378.32 397.65h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.5 95.664 421.011)'
        />
        <path
          d='M379.48 396.92h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 95.456 419.3)'
        />
        <path
          d='M378.89 397.31h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 94.861 419.689)'
        />
        <path
          d='M380 396.64h20.58v.11H380z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 95.971 419.02)'
        />
        <path
          d='M381.17 395.92h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 97.137 418.294)'
        />
        <path
          d='M380.57 396.31h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 96.543 418.683)'
        />
        <path
          d='M381.68 395.7h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 97.653 418.075)'
        />
        <path
          d='M382.85 394.98h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 98.82 417.35)'
        />
        <path
          d='M382.26 395.36h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 98.225 417.74)'
        />
        <path
          d='M383.37 394.69h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 99.335 417.07)'
        />
        <path
          d='M384.54 393.97h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 100.507 416.35)'
        />
        <path
          d='M383.94 394.36h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 99.907 416.733)'
        />
        <path
          d='M385.05 393.7h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 101.024 416.08)'
        />
        <path
          d='M386.22 392.98h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 102.19 415.355)'
        />
        <path
          d='M385.63 393.37h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 101.596 415.744)'
        />
        <path
          d='M386.74 392.7h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 102.706 415.075)'
        />
        <path
          d='M387.9 391.98h20.58v.11H387.9z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 103.878 414.354)'
        />
        <path
          d='M387.31 392.36h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 103.278 414.738)'
        />
        <path
          d='M388.42 391.7H409v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 104.383 414.075)'
        />
        <path
          d='M389.58 390.98h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 105.555 413.355)'
        />
        <path
          d='M388.99 391.36h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 104.954 413.739)'
        />
        <path
          d='M390.1 390.69h20.58v.11H390.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.5 107.456 414.004)'
        />
        <path
          d='M391.27 389.97h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 107.237 412.35)'
        />
        <path
          d='M390.67 390.36h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 106.636 412.733)'
        />
        <path
          d='M391.78 389.75h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 107.753 412.13)'
        />
        <path
          d='M392.95 389.03h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 108.919 411.405)'
        />
        <path
          d='M392.36 389.41h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 108.33 411.788)'
        />
        <path
          d='M393.47 388.74h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 109.435 411.125)'
        />
        <path
          d='M394.04 388.41h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 110.011 410.782)'
        />
        <path
          d='M392.17 391.32a26.14 26.14 0 0 1-5.79-.58v-.11a25.67 25.67 0 0 0 6.24.58v.11zM392.12 390.74a23.72 23.72 0 0 1-5.49-.56v-.1a24.75 24.75 0 0 0 6 .55v.11zM392.22 392.49a27.73 27.73 0 0 1-6.06-.61v-.1a28.15 28.15 0 0 0 6.47.59v.11zM392.2 391.9a27.29 27.29 0 0 1-5.93-.59v-.11a27.24 27.24 0 0 0 6.36.59v.11zM392.14 393.54A28.54 28.54 0 0 1 386 393v-.1a30 30 0 0 0 6.62.58v.1zM392.23 393a28.53 28.53 0 0 1-6.16-.61v-.1a28.94 28.94 0 0 0 6.56.6v.11zM392.19 394.7a31.6 31.6 0 0 1-6.47-.61v-.1a32 32 0 0 0 6.9.6v.11zM392.15 394.12a31 31 0 0 1-6.32-.58v-.11a31.66 31.66 0 0 0 6.79.58v.11zM392.24 395.86a34.8 34.8 0 0 1-6.74-.62v-.11a34.18 34.18 0 0 0 7.13.62v.11zM392.3 395.28a33.14 33.14 0 0 1-6.68-.68v-.1a33.27 33.27 0 0 0 7 .67v.11zM392.09 397a35.11 35.11 0 0 1-6.81-.59v-.1a36.14 36.14 0 0 0 7.35.57v.12zM392.25 396.44a35.89 35.89 0 0 1-6.86-.63v-.11a35.89 35.89 0 0 0 7.24.63v.11zM392.15 398.08a38.64 38.64 0 0 1-7.09-.6v-.11a39.13 39.13 0 0 0 7.57.6v.1zM392.1 397.49a36.3 36.3 0 0 1-6.93-.59v-.1a37.28 37.28 0 0 0 7.46.58v.11zM392.33 399.24a40.37 40.37 0 0 1-7.47-.74v-.1a40.88 40.88 0 0 0 7.77.73v.11zM392.16 398.66a39.88 39.88 0 0 1-7.21-.61v-.11a40.27 40.27 0 0 0 7.68.61v.11zM392.3 399.82a41.59 41.59 0 0 1-7.56-.71v-.1a42.35 42.35 0 0 0 7.89.7v.11zM392.22 401a44.24 44.24 0 0 1-7.72-.64v-.11a44.24 44.24 0 0 0 8.13.64v.11zM392.3 400.4a43.1 43.1 0 0 1-7.67-.71v-.11a42.57 42.57 0 0 0 8 .71v.11zM392.06 402.15a45.74 45.74 0 0 1-7.8-.6v-.1a47.73 47.73 0 0 0 8.37.59v.1zM392 401.57a43.88 43.88 0 0 1-7.62-.59v-.1a45.27 45.27 0 0 0 8.23.57v.11zM392.1 403.31a49.85 49.85 0 0 1-8.07-.61v-.11a50.37 50.37 0 0 0 8.6.61v.11zM392.08 402.73a48.22 48.22 0 0 1-7.93-.6V402a49.17 49.17 0 0 0 8.49.6v.11zM392.12 404.36a51.2 51.2 0 0 1-8.29-.62v-.11a52.68 52.68 0 0 0 8.8.62v.11zM392 403.78a50.4 50.4 0 0 1-8.08-.58v-.11a51.88 51.88 0 0 0 8.7.58v.11zM392 405.52a53 53 0 0 1-8.39-.58v-.11a54.44 54.44 0 0 0 9 .58v.11zM392.26 404.94a52.77 52.77 0 0 1-8.53-.71v-.11a52.87 52.87 0 0 0 8.9.71v.11zM392 406.69a56.87 56.87 0 0 1-8.6-.59v-.1a58.45 58.45 0 0 0 9.27.59v.1zM392 406.11a53.72 53.72 0 0 1-8.45-.59v-.1a55.75 55.75 0 0 0 9.14.57v.11zM392 407.85a60.39 60.39 0 0 1-8.88-.6v-.11a60.06 60.06 0 0 0 9.49.6v.11zM392 407.27a57.11 57.11 0 0 1-8.73-.6v-.11a59.82 59.82 0 0 0 9.38.6v.11zM392.06 408.9a62 62 0 0 1-9.12-.62v-.1a65.45 65.45 0 0 0 9.7.61v.11zM392 408.32a61.68 61.68 0 0 1-9-.61v-.11a62.42 62.42 0 0 0 9.58.61v.11zM392 410.06a64.66 64.66 0 0 1-9.26-.58v-.11a66.36 66.36 0 0 0 9.93.58v.11zM392 409.48a63.34 63.34 0 0 1-9.13-.58v-.11a64 64 0 0 0 9.82.58v.11z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-258.81 -270.72)'
        />
        <path
          d='M124.62 139.72l-.11-.02 3.93-20.77.1.02-3.92 20.77zM125.51 139.72l-.11-.02 3.75-20.84.11.02-3.75 20.84zM132.52 140.26h-.11l.16-21.24h.11l-.16 21.24z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M380.09 400.22h21.2v.11h-21.2z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-89.4 124.114 395.602)'
        />
        <path
          d='M131.02 140.11h-.11l.44-21.1h.11l-.44 21.1zM128.38 139.96l-.11-.02 2.27-21.08.11.01-2.27 21.09z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M379.04 400.15h21v.11h-21z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-88.08 120.158 398.656)'
        />
        <path
          d='M377.13 400.01h21.11v.11h-21.11z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-82.95 105.177 411.106)'
        />
        <path
          d='M376.35 399.97h21.04v.11h-21.04z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-81.33 99.883 415.302)'
        />
        <path
          d='M129.44 139.96l-.11-.01 1.45-21.09.11.01-1.45 21.09z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M382.67 410.52l-.61-.12 3.88-19.75a1.7 1.7 0 0 1 1.74-1.35l5.34.32v.62l-5.34-.32a1.06 1.06 0 0 0-1.09.85z'
          style={{
            fill: 'url(#s-22d4241c82-dA)',
          }}
          transform='translate(-258.81 -270.72)'
        />
        <path
          d='M393.15 412.37l-1-.41.07-22.07a1.53 1.53 0 0 1 .75-1.32l20.16-12.18a.41.41 0 0 1 .31 0l.75.23a.4.4 0 0 1 .28.39l-.93 23.24-.93-.06v-21.71a.39.39 0 0 0-.59-.33l-18.12 10.94a1.57 1.57 0 0 0-.75 1.33z'
          style={{
            fill: 'url(#s-22d4241c82-dB)',
          }}
          transform='translate(-258.81 -270.72)'
        />
        <path
          d='M393.37 412.23l-.29.29.07-22.1a1.56 1.56 0 0 1 .75-1.33l20-12.07a.39.39 0 0 1 .59.34V398a3.15 3.15 0 0 1-.91 2.2V379a.39.39 0 0 0-.59-.33l-18.12 10.94a1.54 1.54 0 0 0-.75 1.33v19.53a2.47 2.47 0 0 1-.75 1.76z'
          style={{
            fill: 'url(#s-22d4241c82-dC)',
          }}
          transform='translate(-258.81 -270.72)'
        />
      </g>
      <g
        id='unihockeyRight'
      >
        <path
          d='M419.12 173.59l-50.84-3.3-4.08-32.27 45.55 2.72 9.37 32.85z'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
        />
        <path
          d='M407.15 165.53l10.95.62v-1l-6.54-19.46-9.71.22v1l8.49.47 5.46 17.05-8.65.1v1z'
          style={{
            fill: 'url(#s-22d4241c82-dD)',
          }}
        />
        <path
          d='M407.16 164.53l10.94.62-6.54-19.46-10.16-.47.52.69 9.03.51 5.86 18.06-9.85-.56.2.61z'
          style={{
            fill: 'url(#s-22d4241c82-dE)',
          }}
        />
        <path
          d='M669.9 417.41c-1 0-2.07 0-3.28-.13v-.1a36.15 36.15 0 0 0 7-.07v.1a34.17 34.17 0 0 1-3.72.2zM669.85 416.89c-1 0-2-.05-3.18-.13v-.1a34 34 0 0 0 6.73-.08v.1a31.81 31.81 0 0 1-3.55.21zM669.89 418.47c-1.06 0-2.17-.05-3.36-.13v-.1a39.61 39.61 0 0 0 7.26-.08v.1a36.22 36.22 0 0 1-3.9.21zM669.89 417.94c-1 0-2.12 0-3.32-.13v-.1a38.31 38.31 0 0 0 7.14-.08v.1a35.16 35.16 0 0 1-3.82.21zM670.07 419.43c-1.12 0-2.29-.05-3.62-.14v-.1a40.68 40.68 0 0 0 7.43-.05v.1c-1.32.13-2.53.19-3.81.19zM669.89 418.89c-1.08 0-2.21 0-3.4-.13v-.1a39.82 39.82 0 0 0 7.36-.08v.1a36.92 36.92 0 0 1-3.96.21zM670.1 420.49c-1.18 0-2.41-.05-3.75-.15v-.1a44.28 44.28 0 0 0 7.75-.05v.1c-1.32.13-2.63.2-4 .2zM670.21 420c-1.18 0-2.42-.06-3.81-.16v-.1a41.88 41.88 0 0 0 7.62 0v.1c-1.26.06-2.5.16-3.81.16zM670.1 421.54q-1.86 0-3.84-.15v-.1a47.18 47.18 0 0 0 8-.05v.1c-1.26.13-2.71.2-4.16.2zM669.63 421c-1.1 0-2.2 0-3.32-.12v-.1a45 45 0 0 0 7.86-.11v.1c-1.55.14-3.04.23-4.54.23zM670.48 422.62c-1.33 0-2.71-.06-4.31-.17v-.1a49.21 49.21 0 0 0 8.24 0v.1c-1.36.11-2.62.17-3.93.17zM670.1 422.06c-1.26 0-2.57 0-3.88-.14v-.1a48.74 48.74 0 0 0 8.13-.05v.1c-1.35.13-2.76.19-4.25.19zM670.52 423.57c-1.39 0-2.85-.06-4.43-.17v-.1a52.12 52.12 0 0 0 8.48 0v.1c-1.33.11-2.66.17-4.05.17zM670.51 423.05c-1.36 0-2.77-.06-4.38-.18v-.1a51.83 51.83 0 0 0 8.36 0v.1c-1.35.13-2.64.18-3.98.18zM669.57 424.58c-1.11 0-2.31 0-3.57-.13v-.1a55.21 55.21 0 0 0 8.73-.1v.1c-1.41.12-3.16.23-5.16.23zM670.54 424.1c-1.43 0-2.91-.06-4.5-.17v-.1a56.16 56.16 0 0 0 8.61 0v.1c-1.34.07-2.65.17-4.11.17zM669.85 425.12c-1.32 0-2.61-.05-3.9-.14v-.1a57 57 0 0 0 8.85-.07v.1c-1.69.14-3.33.21-4.95.21zM670.61 426.2c-1.55 0-3.16-.05-4.75-.17v-.1a61.68 61.68 0 0 0 9.12 0v.1c-1.34.12-2.83.17-4.37.17zM669.91 425.65c-1.36 0-2.69 0-4-.14v-.1a60 60 0 0 0 9-.07v.1c-1.69.14-3.36.21-5 .21zM671.09 427.29c-1.66 0-3.38-.07-5.32-.2V427a64.32 64.32 0 0 0 9.39.06v.1c-1.37.09-2.7.13-4.07.13zM671 426.77c-1.61 0-3.27-.07-5.22-.21v-.1a63.48 63.48 0 0 0 9.22.07v.1c-1.35.09-2.64.14-4 .14zM671.16 428.35c-1.73 0-3.54-.07-5.48-.21V428a69.37 69.37 0 0 0 9.64.07v.1c-1.32.13-2.74.18-4.16.18zM671.13 427.82c-1.7 0-3.47-.07-5.41-.21v-.1a66 66 0 0 0 9.51.07v.1c-1.36.09-2.71.14-4.1.14zM671.4 429.3c-1.66 0-3.38-.07-5.32-.2v-.1a64 64 0 0 0 9.37.06v.1c-1.36.1-2.68.14-4.05.14zM671.5 428.79c-1.81 0-3.73-.07-5.86-.22v-.1a71.38 71.38 0 0 0 9.74.1v.1c-1.24.08-2.53.12-3.88.12zM671.94 430.39c-1.73 0-3.59-.08-5.81-.24v-.1a64.88 64.88 0 0 0 9.46.12v.1c-1.21.08-2.39.12-3.65.12zM670.68 429.79c-1.51 0-3-.06-4.6-.17v-.1a63.3 63.3 0 0 0 9.44 0v.1c-1.74.11-3.3.17-4.84.17zM672 431.45c-1.67 0-3.36-.08-5.66-.24v-.1a64.67 64.67 0 0 0 9.48.12v.1c-1.45.08-2.65.12-3.82.12zM671.89 430.92c-1.65 0-3.29-.08-5.59-.24v-.1a63.45 63.45 0 0 0 9.39.12v.1c-1.42.08-2.61.12-3.8.12zM671.43 432.53c-1.56 0-3.2-.06-5.27-.2v-.1a70 70 0 0 0 9.79.06v.1c-1.62.09-3.03.14-4.52.14zM672 432c-1.74 0-3.5-.08-5.79-.24v-.1a69.87 69.87 0 0 0 9.64.12v.1c-1.37.06-2.6.12-3.85.12zM671.51 433.48c-1.62 0-3.34-.06-5.43-.2v-.1a73.2 73.2 0 0 0 10 .06v.1c-1.57.09-3.02.14-4.57.14zM671.47 433c-1.59 0-3.27-.06-5.34-.21v-.1a71.56 71.56 0 0 0 9.89.07v.1c-1.6.04-3.02.14-4.55.14zM672.07 434.56c-1.92 0-3.86-.07-6.08-.23v-.1a78.87 78.87 0 0 0 10.27.12v.1c-1.44.07-2.81.11-4.19.11zM672 434c-1.87 0-3.74-.07-5.91-.23v-.09a76.83 76.83 0 0 0 10.15.1v.1c-1.54.12-2.92.12-4.24.12z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-258.81 -270.72)'
        />
        <path
          d='M416.62 164.77l-2.29-19.23.1-.01 2.29 19.23-.1.01z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M673.47 416.07h.1v19.56h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-5.8 -2128.253 2844.799)'
        />
        <path
          d='M408.13 164.33h-.09l.07-19.19h.1l-.08 19.19zM408.8 164.3h-.1l.09-19.08h.1l-.09 19.08zM409.53 164.44h-.1l.14-19.22h.1l-.14 19.22z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M670.93 416.02h.1v19.19h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-1.57 -9336.898 9735.11)'
        />
        <path
          d='M410.4 145.22h.1v19.28h-.1z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M671.64 416.05h.1v19.33h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-2.39 -5946.087 6494.47)'
        />
        <path
          d='M672.61 416.06h.1v19.48h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-4.12 -3220.2 3887.896)'
        />
        <path
          d='M670.05 415.94h.1v19.3h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-.81 -18610.305 18595.597)'
        />
        <path
          d='M663.47 398.81c-.7 0-1.44 0-2.26-.07v-.1a28.46 28.46 0 0 0 6.2-.22v.1a26.61 26.61 0 0 1-3.94.29zM663.48 398.29c-.68 0-1.4 0-2.24-.07v-.1a26.93 26.93 0 0 0 6-.21v.1a25.48 25.48 0 0 1-3.76.28zM663.4 399.85c-.72 0-1.46 0-2.25-.07v-.1a31.23 31.23 0 0 0 6.42-.22v.1a30.43 30.43 0 0 1-4.17.29zM663.42 399.33c-.71 0-1.45 0-2.24-.07v-.1a30.18 30.18 0 0 0 6.31-.22v.1a29.31 29.31 0 0 1-4.07.29zM663.58 400.8c-.77 0-1.59 0-2.49-.08v-.1a32.11 32.11 0 0 0 6.58-.2v.1a30 30 0 0 1-4.09.28zM663.38 400.27c-.73 0-1.47 0-2.25-.07v-.1a31.48 31.48 0 0 0 6.52-.23v.1a29.75 29.75 0 0 1-4.27.3zM663.54 401.84c-.8 0-1.63 0-2.51-.07v-.1a35.68 35.68 0 0 0 6.86-.21v.1a33 33 0 0 1-4.35.28zM663.65 401.33c-.81 0-1.66 0-2.59-.09v-.1a33.6 33.6 0 0 0 6.75-.19v.1a29.94 29.94 0 0 1-4.16.28zM663.47 402.88c-.82 0-1.65 0-2.5-.07v-.1a38.05 38.05 0 0 0 7.08-.21v.09a33.79 33.79 0 0 1-4.58.29zM663.14 402.35c-.71 0-1.41 0-2.14-.06v-.1a36.2 36.2 0 0 0 7-.27v.1a36.45 36.45 0 0 1-4.86.33zM663.86 403.94c-.92 0-1.88 0-3-.09v-.1a39.63 39.63 0 0 0 7.3-.16v.1a37.74 37.74 0 0 1-4.3.25zM663.44 403.4c-.82 0-1.66 0-2.5-.07v-.1a38.35 38.35 0 0 0 7.19-.22v.1a35 35 0 0 1-4.69.29zM663.81 404.88c-.94 0-1.91 0-3-.09v-.1a42.94 42.94 0 0 0 7.51-.16v.09a38.05 38.05 0 0 1-4.51.26zM663.85 404.36c-.93 0-1.9 0-3-.09v-.1a40.73 40.73 0 0 0 7.4-.16v.1a38.79 38.79 0 0 1-4.4.25zM663 405.9c-.71 0-1.45 0-2.23-.06v-.1a44.51 44.51 0 0 0 7.72-.28v.1a47.36 47.36 0 0 1-5.49.34zM663.8 405.4c-1 0-1.94 0-3-.08v-.1a43.15 43.15 0 0 0 7.62-.18v.1a39.38 39.38 0 0 1-4.62.26zM663.21 406.43c-.82 0-1.64 0-2.45-.07v-.1a46.17 46.17 0 0 0 7.83-.25v.1a48.36 48.36 0 0 1-5.38.32zM663.72 407.49c-1 0-2 0-3-.09v-.1a48.56 48.56 0 0 0 8.08-.18v.1a44.62 44.62 0 0 1-5.08.27zM663.22 407c-.84 0-1.67 0-2.49-.07v-.1a46.5 46.5 0 0 0 8-.25v.1a48.62 48.62 0 0 1-5.51.32zM664.21 408.55c-1.12 0-2.29 0-3.57-.11v-.1a51.59 51.59 0 0 0 8.31-.12v.1a46.78 46.78 0 0 1-4.74.23zM664.22 408c-1.09 0-2.25 0-3.55-.11v-.1a48.77 48.77 0 0 0 8.17-.12v.1a45.28 45.28 0 0 1-4.62.23zM664.2 409.59c-1.16 0-2.36 0-3.63-.1v-.1a55.56 55.56 0 0 0 8.53-.13v.1a49.18 49.18 0 0 1-4.9.23zM664.21 409.07c-1.14 0-2.33 0-3.6-.1v-.1a54.12 54.12 0 0 0 8.42-.13v.1a47.94 47.94 0 0 1-4.82.23zM664.2 410.54c-1.18 0-2.41 0-3.68-.11v-.1a57 57 0 0 0 8.74-.13v.1c-1.62.16-3.26.24-5.06.24zM664.49 410c-1.23 0-2.54 0-3.94-.12v-.1a56.42 56.42 0 0 0 8.62-.1v.1c-1.47.22-3.01.22-4.68.22zM664.66 411.6c-1.32 0-2.73 0-4.2-.13v-.1a60.51 60.51 0 0 0 8.93-.08v.1c-1.39.14-3.01.21-4.73.21zM663.52 411q-1.53 0-3-.09v-.1a57.39 57.39 0 0 0 8.84-.21v.1c-2.03.24-3.95.3-5.84.3zM664.67 412.65c-1.33 0-2.72 0-4.28-.13v-.1a63.36 63.36 0 0 0 9.19-.08v.1c-1.66.14-3.24.21-4.91.21zM664.66 412.12c-1.31 0-2.67 0-4.23-.13v-.1a60.27 60.27 0 0 0 9.06-.07v.1c-1.67.14-3.2.2-4.83.2zM664.68 413.69c-1.37 0-2.8-.05-4.35-.13v-.1a66.44 66.44 0 0 0 9.41-.08v.1c-1.66.14-3.32.21-5.06.21zM664.68 413.17c-1.36 0-2.76-.05-4.32-.13v-.1a64.88 64.88 0 0 0 9.3-.08v.1c-1.66.14-3.28.21-4.98.21zM664.68 414.63c-1.41 0-2.88 0-4.4-.13v-.1a69.46 69.46 0 0 0 9.62-.08v.1a62.7 62.7 0 0 1-5.22.21zM664.68 414.11c-1.39 0-2.84-.05-4.37-.13v-.1a67.87 67.87 0 0 0 9.51-.08v.1c-1.68.1-3.37.21-5.14.21zM665.2 415.69q-2.36 0-5-.15v-.1a71 71 0 0 0 9.85 0v.1c-1.46.09-3.05.15-4.85.15zM665.12 415.17c-1.52 0-3.14-.05-4.87-.15v-.1a71.06 71.06 0 0 0 9.74 0v.1c-1.51.08-3.13.15-4.87.15z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-258.81 -270.72)'
        />
        <path
          d='M668.15 397.51h.1v19.11h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-7.17 -1621.67 2337.233)'
        />
        <path
          d='M667.43 397.41h.1v19.31h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-6.26 -1937.712 2637.886)'
        />
        <path
          d='M402.66 145.72l-.02-19.11h.1l.02 19.11h-.1z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M662.15 397.42h.1v18.95h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-.13 -118762.944 114351.148)'
        />
        <path
          d='M662.92 397.42h.1v18.94h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-.31 -49511.933 48100.097)'
        />
        <path
          d='M406.78 145.64l-.82-18.95h.1l.82 18.94-.1.01z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M663.71 397.42h.1v18.99h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-.75 -20147.08 20042.938)'
        />
        <path
          d='M665.81 397.41h.1v19.1h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-3.2 -4309.577 4904.389)'
        />
        <path
          d='M666.66 397.42h.1v19.24h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-4.75 -2726.64 3391.516)'
        />
        <path
          d='M664.46 397.32h.1v19.09h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-1.41 -10466.122 10787.363)'
        />
        <path
          d='M669.78 416.77l-2.2-18.13c-.06-.79-.94-.93-1.65-.91l-6-.19v-.57l6 .19c1.88-.05 2.18 1 2.22 1.42l2.19 18.12z'
          style={{
            fill: 'url(#s-22d4241c82-dF)',
          }}
          transform='translate(-258.81 -270.72)'
        />
        <path
          d='M670.48 418.1l-2.19-18.1a1.31 1.31 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.41 1.41 0 0 1 1.34 1.27l2.19 18.13z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-258.81 -270.72)'
        />
        <path
          d='M671 419.39l-2.2-18.13a1.3 1.3 0 0 0-1.24-1.19l-6-.2v-.1l6 .2a1.41 1.41 0 0 1 1.33 1.27l2.2 18.14z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-258.81 -270.72)'
        />
        <path
          d='M671.45 421l-2.19-18.14a1.31 1.31 0 0 0-1.25-1.18l-6-.2v-.1l6 .2a1.42 1.42 0 0 1 1.34 1.27l2.2 18.15z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-258.81 -270.72)'
        />
        <path
          d='M671.9 422.14L669.71 404a1.33 1.33 0 0 0-1.24-1.19l-6-.19v-.1l6 .2a1.41 1.41 0 0 1 1.34 1.27l2.19 18.14z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-258.81 -270.72)'
        />
        <path
          d='M672.36 423.48l-2.19-18.13a1.33 1.33 0 0 0-1.24-1.19l-6-.19v-.1l6 .19a1.43 1.43 0 0 1 1.34 1.28l2.19 18.13z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-258.81 -270.72)'
        />
        <path
          d='M672.83 424.83l-2.2-18.14a1.29 1.29 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.4 1.4 0 0 1 1.33 1.27l2.2 18.13z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-258.81 -270.72)'
        />
        <path
          d='M673.33 426.45l-2.19-18.14a1.31 1.31 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.41 1.41 0 0 1 1.34 1.27l2.19 18.13z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-258.81 -270.72)'
        />
        <path
          d='M673.82 427.86l-2.19-18.13a1.32 1.32 0 0 0-1.25-1.19l-6-.19v-.1l6 .19a1.43 1.43 0 0 1 1.34 1.28l2.19 18.13z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-258.81 -270.72)'
        />
        <path
          d='M674.29 429.3l-2.19-18.14a1.31 1.31 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.42 1.42 0 0 1 1.34 1.27l2.19 18.14z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-258.81 -270.72)'
        />
        <path
          d='M674.77 430.73l-2.19-18.13a1.31 1.31 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.41 1.41 0 0 1 1.34 1.27l2.19 18.13z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-258.81 -270.72)'
        />
        <path
          d='M675.28 432.47l-2.19-18.13a1.31 1.31 0 0 0-1.25-1.18l-6-.2v-.1l6 .2a1.4 1.4 0 0 1 1.33 1.27l2.2 18.13z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-258.81 -270.72)'
        />
        <path
          d='M675.75 433.8l-2.19-18.13a1.31 1.31 0 0 0-1.25-1.18l-6-.2v-.1l6 .2a1.4 1.4 0 0 1 1.33 1.27l2.2 18.13z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-258.81 -270.72)'
        />
        <path
          d='M676 435.41l-2.19-18.13a1.08 1.08 0 0 0-1-1l-6.38-.2v-.57l6.38.2a1.65 1.65 0 0 1 1.57 1.49l2.19 18.12z'
          style={{
            fill: 'url(#s-22d4241c82-dG)',
          }}
          transform='translate(-258.81 -270.72)'
        />
        <path
          d='M664.42 396.79h.1v19.33h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-17.86 -326.543 1094.561)'
        />
        <path
          d='M665.57 396.9h.1v19.37h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-17.47 -344.787 1113.422)'
        />
        <path
          d='M410.74 145.24l-5.71-18.56.09-.03 5.71 18.56-.09.03zM412.03 145.24l-6.09-18.62.09-.03 6.09 18.62-.09.03zM413.09 145.24l-6.3-18.52.09-.03 6.31 18.52-.1.03z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M669.87 397.04h.1v19.52h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-18.69 -281.9 1057.846)'
        />
        <path
          d='M666.17 436.44a.56.56 0 0 1-.57-.57v-20.11L660.88 401v16.46a.57.57 0 0 1-.57.57.58.58 0 0 1-.57-.57v-20.08a.58.58 0 0 1 .48-.57.57.57 0 0 1 .63.39l5.83 18.21a.5.5 0 0 1 .06.24v20.22a.57.57 0 0 1-.57.57z'
          style={{
            fill: 'url(#s-22d4241c82-dH)',
          }}
          transform='translate(-258.81 -270.72)'
        />
      </g>
    </g>
  </Fragment>
)

const defaultProps = {
  children,
  viewBox,
  fillColor: null,
  fillColorRule: '&&& path, &&& use, &&& g',
  size: null
}

const propTypes = {
  fillColor: PropTypes.string,
  fillColorRule: PropTypes.string,
  viewBox: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      height: PropTypes.number.isRequired,
      width: PropTypes.number.isRequired
    })
  ]),
  sizes: (props, name, componentName) => {
    const prop = props[name]
    if (typeof prop !== 'object') { return }
    for (let key in prop) {
      if (!prop[key] || typeof prop[key].width !== 'number' || typeof prop[key].height !== 'number') {
        return new Error(
          'Invalid prop `' + name + '` supplied to `' + componentName + '`. Validation failed.'
        )
      }
    }
  }
}

export default Object.assign(Image, {
  getDimensions,
  getCss,
  defaultProps,
  propTypes,
  displayName: '14x15'
})
